/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-console */
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { Dropdown } from "react-bootstrap";
// eslint-disable-next-line no-unused-vars
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// eslint-disable-next-line no-unused-vars
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
// eslint-disable-next-line no-unused-vars
import { FaEdit, FaTrash, FaRegCalendarPlus } from "react-icons/fa";
// eslint-disable-next-line no-unused-vars
import { FiSave } from "react-icons/fi";
import { TiFlash } from "react-icons/ti";
import { useLocation, useNavigate } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from "recharts";
import { AGENCIAS_DIRECTAS } from "../../constants/permisos";
import { TIPOS_ACTIVIDAD, TIPO_ACTIVIDAD_DEFAULT } from "../../constants/tiposActividad";
import { useAuthContext } from "../../context/auth";
import { useHubHeaderFilters } from "../../pages/Ventas/HubHeaderContext";
import { useVentasDataSync } from "../../pages/Ventas/VentasDataVersionContext";
import {
  getIntermediarios,
  updateCliente,
  getOportunidades,
  getContratos,
  getCategorias,
  getSubcategorias,
  getUsers,
  getClientes,
  updateOportunidad,
  updateContrato,
  getOportunidadesBTL,
  fetchAllActividadesBulk,
  fetchUltimaActividadPorLado,
  createCalendarEvent,
  listCalendarEvents,
  updateCalendarEvent,
  deleteCalendarEvent,
  getPaisCode,
} from "../../utils";
import { getRateForOpp, getImporteEnUSD, sumarImportesPorEstatus } from "../../utils/calculateVentas";
import { fetchTodosLosContactosPorLado, sincronizarContactosCliente } from "../../utils/contactosCliente";
import { DUAL_RUN_ACTIVIDADES, compararDualRunCRM } from "../../utils/dualRunActividades";
import { normalizarEmpresa } from "../../utils/empresaContacto";
import {
  LEER_ACTIVIDAD_PRECALCULADA,
  fetchResumenGrupos,
  fetchResumenContactos,
  fetchUltimoCalculo,
} from "../../utils/getActividadPrecalculada";
import { getImporteFacturable } from "../../utils/getImporteFacturable";
import { getOportunidadDateStatus, getOportunidadRefDate } from "../../utils/oportunidadDateStatus";
import { useCurrency } from "../../utils/useCurrency";
import { useEmpresaProductoFilter } from "../../utils/useEmpresaProductoFilter";
import { useExchangeRates } from "../../utils/useExchangeRates";
import { CategoriaSubcategoriaFilter } from "../CategoriaSubcategoriaFilter";
import { FlashEditModal } from "../FlashEditModal";
import { Loader } from "../Loader";
import { ActividadesRecientes } from "./components/ActividadesRecientes";
import { AgendarMovimientoModal } from "./components/AgendarMovimientoModal";
import styles from "./VentasMiListaClientesV2.module.scss";

export const VentasMiListaClientesV2 = ({ renderHeader, filterStyles, tabKey }) => {
  // Invalidación cross-tab del hub (2026-09-22, ver VentasDataVersionContext.js y
  // docs/modulos/ventas-hub.md): SOLO el lado productor esta sesión — el CRM avisa al resto del
  // hub (Pizarra, Detalle) cuando escribe una oportunidad, pero NO se hizo consumidor todavía
  // (no recarga solo cuando queda desactualizado). Alcance deliberado: este archivo es enorme y
  // frágil (optimización de carga en curso, PAUSADA esperando el OK visual de Ignacio — ver
  // EN-CURSO histórico), tocar su efecto de carga principal para sumar el lado consumidor es un
  // riesgo mayor al que pide esta tarea (la verificación pedida es Pizarra↔Detalle, no CRM).
  // `useVentasDataSync(false)`: `active` fijo en `false` porque acá no se usa el lado `stale` —
  // solo `bump`, que no depende de `active` para funcionar.
  const { bump: bumpVersionDatos } = useVentasDataSync(false);
  const s = filterStyles || styles;
  const [clientes, setClientesPublicitarios] = useState([]);
  // Proyecto Contactos, Fase 2 (CRM, solo lectura): TODOS los contactos por lado, sin tope de 4 —
  // fuente única `fetchTodosLosContactosPorLado` (10.229), Map<cliente_id, usuario_id[]> por lado,
  // orden por `id` ascendente, agencia sin OMNET. Reemplaza las lecturas de `contacto_X_N` que
  // hacían la columna Contacto, los filtros/búsqueda por usuario y los contactIds de
  // ActividadesRecientes (camino no precalculado) — ver docs/modulos/clientes.md.
  const [contactosPorLado, setContactosPorLado] = useState({ cliente: new Map(), agencia: new Map() });
  // Estado local del toggle "+N más"/"ver menos" — cerrado por defecto, no persiste. Clave
  // `${clienteId}|${lado}` para que cada fila y cada lado se expandan de forma independiente.
  const [contactosExpandido, setContactosExpandido] = useState(new Set());
  const toggleContactosExpandido = (clienteId, lado) => {
    setContactosExpandido((prev) => {
      const clave = `${clienteId}|${lado}`;
      const next = new Set(prev);
      if (next.has(clave)) next.delete(clave);
      else next.add(clave);
      return next;
    });
  };
  const [intermediarios, setIntermediarios] = useState([]);
  const [loading, setLoading] = useState(true);
  // Commit 2 (regresión CRM): si la carga base falla, no se pinta el esqueleto ni la tabla — un
  // solo mensaje centrado con reintentar. `reloadTrigger` re-dispara el useEffect de carga base
  // sin duplicar la lógica de fetch en un handler aparte.
  const [errorCargaBase, setErrorCargaBase] = useState(false);
  const [reloadTrigger, setReloadTrigger] = useState(0);
  // OCULTO TEMPORALMENTE: Estados para edición de contactos (reactivar con columnas EDIT y PRÓXIMO CONTACTO)
  /* eslint-disable no-unused-vars */
  const [, setEditingClienteId] = useState(null);
  const [editingClienteContact, setEditingClienteContact] = useState(null);
  const [editingAgenciaContact, setEditingAgenciaContact] = useState(null);
  const [ultimo_contacto_fecha_cliente, setUltimoContactoFechaCliente] = useState(null);
  const [ultimo_contacto_accion_cliente, setUltimoContactoAccionCliente] = useState("");
  const [proximo_contacto_fecha_cliente, setProximoContactoFechaCliente] = useState(null);
  const [proximo_contacto_accion_cliente, setProximoContactoAccionCliente] = useState("");
  const [ultimo_contacto_fecha_agencia, setUltimoContactoFechaAgencia] = useState(null);
  const [ultimo_contacto_accion_agencia, setUltimoContactoAccionAgencia] = useState("");
  const [proximo_contacto_fecha_agencia, setProximoContactoFechaAgencia] = useState(null);
  const [proximo_contacto_accion_agencia, setProximoContactoAccionAgencia] = useState("");
  /* eslint-enable no-unused-vars */
  const [todasLasOportunidades, setTodasLasOportunidades] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroMes, setFiltroMes] = useState([]);
  const [filtroEstatus, setFiltroEstatus] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroSubcategoria, setFiltroSubcategoria] = useState("");
  const [subcategorias, setSubcategorias] = useState([]);
  const [sumasFiltradas, setSumasFiltradas] = useState({
    "100%": 0,
    "90%": 0,
    "75%": 0,
    "50%": 0,
    "0%": 0,
  });
  const [sumCierres, setSumCierres] = useState(0);
  const [usuarios, setUsuarios] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [ordenamiento] = useState({ porFecha: "null" });
  // Orden por antigüedad de oportunidad (clic en header "Oportunidades"):
  // null = orden default (tiers/montos) · "asc" = más antigua primero · "desc" = más reciente primero.
  const [ordenPorAntiguedad, setOrdenPorAntiguedad] = useState(null);
  const cycleOrdenAntiguedad = () =>
    setOrdenPorAntiguedad((prev) => (prev === null ? "asc" : prev === "asc" ? "desc" : null));
  const [data, setData] = useState([
    {
      name: "Total",
      "100%": 0,
      "90%": 0,
      "75%": 0,
      "50%": 0,
      "0%": 0,
      empty: 100,
    },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [tipoCliente, setTipoCliente] = useState("");
  const [filtroCategoriaCliente, setFiltroCategoriaCliente] = useState([]);
  // Filtro bidireccional empresa↔producto (lógica centralizada). El state de empresa se llama
  // `filtroCliente` (alias) por compatibilidad con el filtrado de tabla por nombre/empresa.
  const {
    filtroEmpresa: filtroCliente,
    filtroProducto,
    productosDeEmpresa,
    empresasDeProducto,
    empresaDisabled,
    productoDisabled,
    onChangeEmpresa,
    onChangeProducto,
  } = useEmpresaProductoFilter(clientes);

  // Deep-link desde Alertas de recurrencia comercial (AlertasRecurrenciaBanner, Home de admin):
  // navega acá con `location.state.filtroEmpresaAlerta` (el `empresaDisplay` exacto de
  // agruparClientesPorEmpresa, 10.276) y pre-aplica el filtro Empresa existente — reusa
  // `onChangeEmpresa`, no reimplementa el filtrado. `aplicadoRef` evita reaplicar en cada render
  // (la tab queda montada/keep-alive, ver Ventas/index.js) y solo reacciona a un state NUEVO.
  const location = useLocation();
  const filtroEmpresaAlertaRef = useRef(null);
  useEffect(() => {
    const valor = location.state?.filtroEmpresaAlerta;
    if (valor && valor !== filtroEmpresaAlertaRef.current) {
      filtroEmpresaAlertaRef.current = valor;
      onChangeEmpresa(valor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState(null);
  const [selectedOportunidadId, setSelectedOportunidadId] = useState(null);
  const [flashEditingOpportunity, setFlashEditingOpportunity] = useState(null);
  const [isFlashEditing, setIsFlashEditing] = useState(false);
  const [flashSaving, setFlashSaving] = useState(false);
  const [filtroUsuario, setFiltroUsuario] = useState("");
  const [todasLasOportunidadesBTL, setTodasLasOportunidadesBTL] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  // Con LEER_ACTIVIDAD_PRECALCULADA=true, actividadesCRM guarda SOLO las SALE sintéticas (ventas
  // 100% cerradas) derivadas de todasLasOportunidades — MAIL/MEET/CALL vienen de
  // gruposActividadCRM (crm_actividad_resumen_grupos). Con el flag en false, sigue siendo el
  // array completo (mail/meet/call/sale) del camino viejo, sin cambios.
  const [actividadesCRM, setActividadesCRM] = useState({}); // { clienteId: [actividades] }
  // Grupos (tipo, día) por cliente+lado, ya calculados por SQL: { clienteId: { agencia: [...], cliente: [...] } }
  const [gruposActividadCRM, setGruposActividadCRM] = useState({});
  // Última actividad histórica por lado, para fallback "Último dd/mm/yy": { clienteId: { agencia, cliente } }
  const [ultimaActividadPorLado, setUltimaActividadPorLado] = useState({});
  // calculado_at de la última corrida del cron (marca "actualizado HH:MM" del header) — null hasta
  // que se resuelve; si el cron nunca corrió, sigue null y el header lo dice (10.177).
  const [actividadCalculadoAt, setActividadCalculadoAt] = useState(null);
  const [loadingCRM, setLoadingCRM] = useState(true);
  // Google Calendar (agenda futura) se difiere hasta que la oleada 1 de actividades ya pintó, para
  // no competir por las ~6 conexiones del browser durante la carga crítica (Fase 3A). Se resetea a
  // false en cada cambio de país (en el fetchData) y vuelve a true cuando la oleada 1 pinta.
  const [crmPrioridadCargada, setCrmPrioridadCargada] = useState(false);
  const [ventasData, setVentasData] = useState({
    ventasPorCliente: {},
    ventasYTD: {},
    ventasAA: {}, // Año Anterior (2025)
    ventasHTD: {},
    oportunidades90: {},
    oportunidades75: {},
    oportunidades50: {},
  });
  const getCurrentYear = () => new Date().getFullYear().toString();
  const CURRENT_YEAR = getCurrentYear(); // "2026"
  const { pais, rol, id } = useAuthContext() || {};
  const { formatAmount } = useCurrency();

  const { getDolarValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);
  const fallbackRate = dolarFallback?.[pais] || 1;

  const [viewInUSD, setViewInUSD] = useState(false);

  // ── Agenda futura (Google Calendar) ──
  const [agendarOpen, setAgendarOpen] = useState(false);
  const [agendarCtx, setAgendarCtx] = useState(null); // { cliente, lado, evento? }
  const [agendarSaving, setAgendarSaving] = useState(false);
  const [agendarDeleting, setAgendarDeleting] = useState(false);
  // Eventos futuros (90d) agrupados por `${client_id}-${lado}`.
  const [agendaEventos, setAgendaEventos] = useState({});

  const agendaKey = (clientId, lado) => `${clientId}-${lado}`;
  const startOf = (ev) => ev?.start?.dateTime || ev?.start?.date;

  // Gate AdLab: clientes de Perú brokereados por AdLab (intermediario id 115) no
  // se agendan desde acá — su agenda la maneja el broker. Comparación por ID.
  // useCallback → referencia estable (dep de clientesFiltradosBase sin romper la memo).
  const esBrokerAdLab = useCallback((cliente) => pais === "Perú" && String(cliente?.broker_id) === "115", [pais]);

  // Atribución de grupo (Visiona/AdLab) de UNA CUENTA. Decisión PER-CUENTA por `broker_id`
  // ACTUAL (`esBrokerAdLab`), sin excepción por fecha: esta pantalla es gestión de cartera CRM,
  // no revenue histórico. La cuenta entera (todas sus oportunidades/ventas y los KPIs asociados)
  // va a AdLab si `broker_id===115`, a Visiona si no — NUNCA partida entre ambos.
  //  - `opp`/`esBTL` se conservan en la firma pero se IGNORAN: los consumidores de KPIs iteran
  //    opps y llaman por-opp, pero la decisión sale de la cuenta, así toda opp de una cuenta cae
  //    del mismo lado que la cuenta en la tabla (totales sin huecos ni duplicados entre grupos).
  //  - Cualquier otro valor (id de persona o "") → true (pass-through, no filtra por grupo).
  //  - NO usa `esVentaEnPeriodoBroker`: ese sigue rigiendo comisiones / ejecutivo "ADLAB" /
  //    VentasDetalle sin cambios; el criterio por-fecha es exclusivo de esas otras pantallas.
  const matchGrupoOpp = useCallback(
    (filtro, _opp, cliente, _esBTL) => {
      if (filtro === "grupo:adlab") return esBrokerAdLab(cliente);
      if (filtro === "grupo:visiona") return !esBrokerAdLab(cliente);
      return true;
    },
    [esBrokerAdLab]
  );

  // Predicado ÚNICO de pertenencia persona↔ejecutivo (caso NO grupo). Un cliente es del
  // ejecutivo filtrado si es su `ejecutivo` primario O está en `ejecutivos_asignados`.
  // SIEMPRE por String: `ejecutivos_asignados` es int8[] y PostgREST lo entrega como array
  // de strings ("['4','306']"), así que `.includes(Number(...))` nunca matchea (regla 10.7).
  // Fuente única compartida por filas (clientesFiltradosBase), cards (filtrarOportunidades)
  // y Facturación/cierres (calcularSumasFiltradas) → tabla y KPIs no pueden volver a divergir.
  const clienteMatcheaEjecutivoPersona = useCallback(
    (cliente, filtroEj) =>
      String(cliente?.ejecutivo) === String(filtroEj) ||
      (Array.isArray(cliente?.ejecutivos_asignados) &&
        cliente.ejecutivos_asignados.map(String).includes(String(filtroEj))),
    []
  );

  // Fase 3: modo AdLab de la columna ACTIVIDAD RECIENTE (solo cierres período-broker).
  const modoAdLabActividad = filtroEjecutivo === "grupo:adlab";

  // Una sola llamada list (todos los eventos wecast_crm futuros del usuario),
  // agrupados por cliente+lado. Se dispara al montar la vista.
  const cargarAgenda = useCallback(async () => {
    if (!id) return;
    try {
      // [perf] temporal, quitar al cerrar la optimización de Ventas (ROADMAP_TECNICO.md)
      const perfT0Cal = performance.now();
      const { events } = await listCalendarEvents({ usuario_id: id, pais: getPaisCode(pais) });
      // [perf] temporal
      console.log(
        "[perf][CRM] ola Google Calendar (listCalendarEvents): " +
          `${Math.round(performance.now() - perfT0Cal)}ms — ${(events || []).length} eventos`
      );
      const grouped = {};
      (events || []).forEach((ev) => {
        const cid = ev.private?.client_id;
        const l = ev.private?.lado;
        if (cid == null || !l) return;
        const k = agendaKey(cid, l);
        if (!grouped[k]) grouped[k] = [];
        grouped[k].push(ev);
      });
      Object.keys(grouped).forEach((k) =>
        grouped[k].sort((a, b) => new Date(startOf(a)).getTime() - new Date(startOf(b)).getTime())
      );
      setAgendaEventos(grouped);
    } catch (err) {
      if (err.code === "NEEDS_RECONNECT") {
        toast.error("Reconectá Google desde tu Perfil para ver tu agenda.");
      } else if (err.code !== "NO_TOKEN") {
        console.warn("cargarAgenda:", err.message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, pais]);

  // Google Calendar NO se dispara en el mount (competía con la oleada 1 por las conexiones): espera
  // a que la oleada 1 de actividades haya pintado (crmPrioridadCargada). Sigue sin bloquear el
  // render (es async y su resultado solo alimenta la columna Agenda futura). Ver Fase 3A / ROADMAP.
  useEffect(() => {
    if (!crmPrioridadCargada) return;
    cargarAgenda();
  }, [crmPrioridadCargada, cargarAgenda]);

  // Evento más próximo (futuro) para una celda; los grupos vienen ordenados asc.
  const proximoEvento = (clientId, lado) => {
    const arr = agendaEventos[agendaKey(clientId, lado)];
    if (!arr || arr.length === 0) return null;
    const now = Date.now();
    return arr.find((ev) => new Date(startOf(ev)).getTime() >= now) || null;
  };

  // Último evento VENCIDO (start < ahora) para una celda. El grupo viene ordenado
  // ascendente, así que recorriendo desde el final el primero con fecha < ahora es
  // el vencido más reciente. null si no hay ninguno vencido.
  const ultimoVencido = (clientId, lado) => {
    const arr = agendaEventos[agendaKey(clientId, lado)];
    if (!arr || arr.length === 0) return null;
    const now = Date.now();
    for (let i = arr.length - 1; i >= 0; i--) {
      if (new Date(startOf(arr[i])).getTime() < now) return arr[i];
    }
    return null;
  };

  // Agrega/actualiza un evento en el estado local (sin re-fetch). oldId: al editar,
  // remueve la versión previa (mismo id) antes de re-insertar; recalcula orden.
  const upsertAgendaLocal = (clientId, lado, evento, oldId) => {
    setAgendaEventos((prev) => {
      const k = agendaKey(clientId, lado);
      const arr = (prev[k] || []).filter((e) => e.id !== evento.id && e.id !== oldId);
      arr.push(evento);
      arr.sort((a, b) => new Date(startOf(a)).getTime() - new Date(startOf(b)).getTime());
      return { ...prev, [k]: arr };
    });
  };

  const removeAgendaLocal = (clientId, lado, eventId) => {
    setAgendaEventos((prev) => {
      const k = agendaKey(clientId, lado);
      return { ...prev, [k]: (prev[k] || []).filter((e) => e.id !== eventId) };
    });
  };

  const handleOpenAgendar = (cliente, lado) => {
    setAgendarCtx({ cliente, lado, evento: null });
    setAgendarOpen(true);
  };

  const handleOpenEditar = (cliente, lado, evento) => {
    setAgendarCtx({ cliente, lado, evento });
    setAgendarOpen(true);
  };

  const handleCloseAgendar = () => {
    if (agendarSaving || agendarDeleting) return;
    setAgendarOpen(false);
    setAgendarCtx(null);
  };

  const handleSaveAgendar = async (fields) => {
    if (!agendarCtx) return;
    const { cliente, lado, evento } = agendarCtx;
    try {
      setAgendarSaving(true);
      const base = {
        usuario_id: id,
        pais: getPaisCode(pais),
        tipo: fields.tipo,
        tipo_label: fields.tipo_label,
        cliente_nombre: cliente.empresa || cliente.nombre || "",
        fecha_inicio: fields.fecha_inicio,
        nota: fields.nota,
      };
      const { event } = evento
        ? await updateCalendarEvent({ ...base, event_id: evento.id })
        : await createCalendarEvent({ ...base, client_id: cliente.id, lado });
      upsertAgendaLocal(cliente.id, lado, event, evento?.id);
      toast.success(evento ? "Evento actualizado" : "Evento agendado en tu Google Calendar");
      setAgendarOpen(false);
      setAgendarCtx(null);
    } catch (err) {
      if (err.code === "NEEDS_RECONNECT") {
        toast.error("Necesitás reconectar Google (permiso de Calendar) desde tu Perfil.");
      } else {
        toast.error(err.message || "Error al guardar el evento");
      }
    } finally {
      setAgendarSaving(false);
    }
  };

  const handleDeleteAgendar = async () => {
    if (!agendarCtx?.evento) return;
    const { cliente, lado, evento } = agendarCtx;
    try {
      setAgendarDeleting(true);
      await deleteCalendarEvent({ usuario_id: id, pais: getPaisCode(pais), event_id: evento.id });
      removeAgendaLocal(cliente.id, lado, evento.id);
      toast.success("Evento borrado");
      setAgendarOpen(false);
      setAgendarCtx(null);
    } catch (err) {
      if (err.code === "NEEDS_RECONNECT") {
        toast.error("Necesitás reconectar Google (permiso de Calendar) desde tu Perfil.");
      } else {
        toast.error(err.message || "Error al borrar el evento");
      }
    } finally {
      setAgendarDeleting(false);
    }
  };

  // Celda "Agenda futura" por lado: badge del próximo evento futuro (púrpura), o
  // si no hay futuro, el último vencido en gris (conserva el registro; clic para
  // reagendar), o ícono "+" para agendar. "AdLab" si el cliente es brokereado.
  const renderMovFuturosCell = (cliente, lado) => {
    if (esBrokerAdLab(cliente)) {
      return <span style={{ color: "#666", fontStyle: "italic", fontSize: "0.8rem" }}>AdLab</span>;
    }

    // Badge PROPIO de Agenda Futura (independiente del de ActividadesRecientes):
    // mismo layout para futuro y vencido, parametrizando color/title/onClick.
    // Contenido = label completo (no abreviado) + dd/mm del evento.
    const renderBadge = (ev, { bg, color, title, onClick }) => {
      const cfg = TIPOS_ACTIVIDAD[ev.private?.tipo] || TIPOS_ACTIVIDAD[TIPO_ACTIVIDAD_DEFAULT];
      const label = cfg.labelAgenda || cfg.label || ev.private?.tipo;
      const d = new Date(startOf(ev));
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      return (
        <div
          role="button"
          title={title}
          onClick={onClick}
          style={{
            cursor: "pointer",
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            width: 72,
            backgroundColor: bg,
            color,
            borderRadius: 6,
            padding: "6px 4px",
            gap: 3,
          }}
        >
          <span
            style={{
              fontSize: "0.8rem",
              fontWeight: 700,
              lineHeight: 1.1,
              textAlign: "center",
              whiteSpace: "normal",
              wordBreak: "normal",
            }}
          >
            {label}
          </span>
          <span style={{ fontSize: "0.8rem", fontWeight: 600, lineHeight: 1 }}>
            {dd}/{mm}
          </span>
        </div>
      );
    };

    // Con futuro: badge púrpura (clic → editar), como siempre.
    const futuro = proximoEvento(cliente.id, lado);
    if (futuro) {
      return renderBadge(futuro, {
        bg: "#7e22ce",
        color: "#fff",
        title: futuro.summary,
        onClick: () => handleOpenEditar(cliente, lado, futuro),
      });
    }

    // Sin futuro pero con vencido: badge gris claro (clic → reagendar; el modal
    // abre en editar y reinicia la fecha al futuro, conservando tipo y nota).
    const vencido = ultimoVencido(cliente.id, lado);
    if (vencido) {
      return renderBadge(vencido, {
        bg: "#e5e7eb",
        color: "#6b7280",
        title: "Vencido — clic para reagendar",
        onClick: () => handleOpenEditar(cliente, lado, vencido),
      });
    }

    // Sin eventos: ícono "+" para agendar.
    return (
      <FaRegCalendarPlus
        title="Agenda futura"
        style={{ cursor: "pointer", fontSize: "1.4rem", color: "#0d6efd" }}
        onClick={() => handleOpenAgendar(cliente, lado)}
      />
    );
  };

  const navigate = useNavigate();

  // react-hook-form ya no se usa, Flash modal maneja su propio estado

  const clientesMemo = useMemo(() => clientes, [clientes]);

  const todasLasOportunidadesMemo = useMemo(() => todasLasOportunidades, [todasLasOportunidades]);

  const todasLasOportunidadesBTLMemo = useMemo(() => todasLasOportunidadesBTL, [todasLasOportunidadesBTL]);

  // Set por-identidad de opps BTL: en los merges [...pauta, ...BTL] permite distinguir
  // el origen sin depender de ids (que pueden colisionar entre tablas). Usado por el
  // filtro de grupo (Visiona/AdLab) de la celda OPORTUNIDADES.
  const btlOppSet = useMemo(() => new Set(todasLasOportunidadesBTL), [todasLasOportunidadesBTL]);

  const clienteCategoriaMap = useMemo(() => {
    const map = {};
    clientes.forEach((cliente) => {
      if (cliente.categoria == null) {
        map[cliente.id] = "";
        return;
      }
      const categoria = categorias.find((cat) => cat?.id != null && cat.id.toString() === cliente.categoria.toString());
      map[cliente.id] = categoria ? categoria.nombre : "";
    });
    return map;
  }, [clientes, categorias]);

  // Conversión USD → moneda local con rate histórico por fecha de la opp.
  // Si moneda_dolar=false, retorna el importe sin tocar.
  const getConvertedImporte = useCallback(
    (oportunidad) => {
      const importe = oportunidad.importe || 0;
      if (!oportunidad.moneda_dolar) return importe;
      const rate = getRateForOpp(oportunidad, getDolarValue, fallbackRate);
      return importe * rate;
    },
    [getDolarValue, fallbackRate]
  );

  const getConvertedImporteBTL = useCallback(
    (oportunidadBTL) => {
      const importe = oportunidadBTL.total_investment || 0;
      if (!oportunidadBTL.moneda_dolar) return importe;
      const rate = getRateForOpp(oportunidadBTL, getDolarValue, fallbackRate);
      return importe * rate;
    },
    [getDolarValue, fallbackRate]
  );

  const normalizeMonth = (month, createdAt, ano = null) => {
    if (!month || typeof month !== "string") {
      if (ano) return `01-${ano}`;
      return null;
    }
    if (/^\d{2}-\d{4}$/.test(month)) return month;
    const monthNum = parseInt(month, 10);
    if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && ano) {
      return `${monthNum.toString().padStart(2, "0")}-${ano}`;
    }
    return null;
  };

  const calculateSalesSums = (
    oportunidades,
    oportunidadesBTL,
    year,
    startMonth = 1,
    endMonth = 12,
    pais,
    inUSD = false
  ) => {
    const filterAndSum = (ops, status, field, isBTL = false) => {
      const filteredOps = ops.filter((op) => {
        const useField = op[field] ? field : op.estatus === "100%" && !isBTL ? "mes_cierre" : null;
        if (!useField || !op[useField]) {
          return false;
        }
        const [month, ano] = op[useField].split("-").map(Number);
        const estatus = isBTL ? (op.status === 100 ? "100%" : `${op.status || 0}%`) : op.estatus;
        return estatus === status &&
          !op.eliminada &&
          ano === parseInt(year) &&
          month >= startMonth &&
          month <= endMonth &&
          op.pais === pais
          ? true
          : false;
      });
      // Proyección de pipeline por estatus (10.272, src/utils/calculateVentas.js): 100% suma
      // todo, 90%/75%/50%/0% cuentan una sola oportunidad por cliente y estatus (la de menor
      // monto) — fuente única con VentasDetalle y VentasMiListaClientes.
      return sumarImportesPorEstatus(
        filteredOps,
        (op) => {
          const bruto = inUSD
            ? getImporteEnUSD(op, getDolarValue, fallbackRate)
            : isBTL
              ? getConvertedImporteBTL(op)
              : getConvertedImporte(op);
          // Facturación (mes_factura) muestra el facturable (descuento de acuerdo, 7.22); Cierres
          // (mes_cierre) y pipeline muestran el valor de lista. BTL no tiene descuento de acuerdo.
          return field === "mes_factura" && !isBTL
            ? getImporteFacturable({ importe: bruto, descuento_acuerdo_pct: op.descuento_acuerdo_pct })
            : bruto;
        },
        status
      );
    };
    const sumCierresRegular = filterAndSum(oportunidades, "100%", "mes_cierre", false);
    const sumCierresBTL = filterAndSum(oportunidadesBTL, "100%", "mes_cierre", true);
    const sumaImportes100Regular = filterAndSum(oportunidades, "100%", "mes_factura", false);
    const sumaImportes100BTL = filterAndSum(oportunidadesBTL, "100%", "mes_factura", true);
    const sumaImportes90 = filterAndSum(oportunidades, "90%", "mes_cierre", false);
    const sumaImportes75 = filterAndSum(oportunidades, "75%", "mes_cierre", false);
    const sumaImportes50 = filterAndSum(oportunidades, "50%", "mes_cierre", false);
    const sumaImportes0 = filterAndSum(oportunidades, "0%", "mes_cierre", false);
    return {
      sumCierres: sumCierresRegular + sumCierresBTL,
      sumaImportes100: sumaImportes100Regular + sumaImportes100BTL,
      sumaImportes90,
      sumaImportes75,
      sumaImportes50,
      sumaImportes0,
    };
  };

  const calculateVentasYOportunidades = (
    oportunidades,
    oportunidadesBTL,
    clientes,
    currentYear = CURRENT_YEAR,
    inUSD = false
  ) => {
    const ventasPorCliente = {};
    const ventasYTD = {}; // Ventas que se facturarán en el año actual
    const ventasAA = {}; // Ventas del año anterior (2025)
    const ventasHTD = {}; // Ventas facturadas en años anteriores (excluyendo año actual y AA)
    const previousYear = String(Number(currentYear) - 1); // 2025

    // Helper para obtener el año de facturación
    const getFacturaYear = (op) => {
      // Prioridad 1: facturafecha
      if (op.facturafecha) {
        const facturaDate = new Date(op.facturafecha);
        if (!isNaN(facturaDate.getTime())) {
          return String(facturaDate.getFullYear());
        }
      }
      // Prioridad 2: mes_factura (formato "MM-YYYY")
      if (op.mes_factura) {
        const parts = op.mes_factura.split("-");
        if (parts.length === 2) {
          return parts[1];
        }
      }
      return null;
    };

    // Procesar oportunidades publicitarias
    oportunidades.forEach((op) => {
      const estatus = op.estatus ? op.estatus.trim() : "0%";
      if (!op.eliminada && op.pais === pais && estatus === "100%") {
        const clientId = op.client_id;
        const bruto = inUSD ? getImporteEnUSD(op, getDolarValue, fallbackRate) : getConvertedImporte(op);
        // Facturación → facturable (descuento de acuerdo, 7.22). Sin descuento, devuelve el importe.
        const importe = getImporteFacturable({ importe: bruto, descuento_acuerdo_pct: op.descuento_acuerdo_pct });

        // Determinar el año de FACTURACIÓN (no de cierre)
        const facturaYear = getFacturaYear(op);

        // Total general (mantener compatibilidad)
        if (!ventasPorCliente[clientId]) ventasPorCliente[clientId] = 0;
        ventasPorCliente[clientId] += importe;

        // YTD: Facturación del año actual
        if (facturaYear === currentYear) {
          if (!ventasYTD[clientId]) ventasYTD[clientId] = 0;
          ventasYTD[clientId] += importe;
        }

        // AA: Facturación del año anterior (2025)
        if (facturaYear === previousYear) {
          if (!ventasAA[clientId]) ventasAA[clientId] = 0;
          ventasAA[clientId] += importe;
        }

        // HTD: Suma histórica de TODOS los años excepto el actual (incluye AA)
        if (facturaYear && facturaYear !== currentYear) {
          if (!ventasHTD[clientId]) ventasHTD[clientId] = 0;
          ventasHTD[clientId] += importe;
        }
      }
    });

    // Procesar oportunidades BTL
    oportunidadesBTL.forEach((opBTL) => {
      const estatus = opBTL.estatus ? opBTL.estatus.trim() : opBTL.status ? `${opBTL.status}%` : "0%";
      if (!opBTL.eliminada && opBTL.pais === pais && (estatus === "100%" || opBTL.status === 100)) {
        const clientId = opBTL.client_id;
        const importe = inUSD ? getImporteEnUSD(opBTL, getDolarValue, fallbackRate) : getConvertedImporteBTL(opBTL);

        // Determinar el año de FACTURACIÓN (no de cierre)
        const facturaYear = getFacturaYear(opBTL);

        // Total general
        if (!ventasPorCliente[clientId]) ventasPorCliente[clientId] = 0;
        ventasPorCliente[clientId] += importe;

        // YTD: Facturación del año actual
        if (facturaYear === currentYear) {
          if (!ventasYTD[clientId]) ventasYTD[clientId] = 0;
          ventasYTD[clientId] += importe;
        }

        // AA: Facturación del año anterior (2025)
        if (facturaYear === previousYear) {
          if (!ventasAA[clientId]) ventasAA[clientId] = 0;
          ventasAA[clientId] += importe;
        }

        // HTD: Suma histórica de TODOS los años excepto el actual (incluye AA)
        if (facturaYear && facturaYear !== currentYear) {
          if (!ventasHTD[clientId]) ventasHTD[clientId] = 0;
          ventasHTD[clientId] += importe;
        }
      }
    });

    return [ventasPorCliente, ventasYTD, ventasAA, ventasHTD];
  };

  const getIntermediarioNombre = useCallback(
    (intermediarioValue) => {
      if (typeof intermediarioValue === "string" && !/^\d+$/.test(intermediarioValue)) return intermediarioValue;
      const intermediario = intermediarios.find(
        (inter) => String(inter.id) === String(intermediarioValue) && inter.pais === pais
      );
      return intermediario ? intermediario.nombre : "";
    },
    [intermediarios, pais]
  );

  const sortContacts = (contactIds, usuarios, type, priorityRoles) => {
    const validContacts = contactIds
      .filter((id) => id && usuarios.find((user) => String(user.id) === String(id)))
      .map((id) => usuarios.find((user) => String(user.id) === String(id)))
      .sort((a, b) => {
        const roleA = a.rol ? a.rol.toLowerCase().trim() : "";
        const roleB = b.rol ? b.rol.toLowerCase().trim() : "";
        const priorityA = priorityRoles.indexOf(roleA);
        const priorityB = priorityRoles.indexOf(roleB);
        if (priorityA !== priorityB) return priorityA - priorityB;
        return `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`);
      });
    return validContacts;
  };

  // Proyecto Contactos, Fase 2 — "+N más"/"ver menos": con 4 contactos o menos no cambia nada (los
  // mismos 4 nombres de siempre, mismo alto de fila). Con más de 4 Y colapsado, el toggle ocupa el
  // 4º lugar (3 nombres reales + el toggle, nunca 5 líneas) — así la celda de contactos NUNCA
  // supera las 4 líneas de siempre y el alto de fila queda idéntico al de un cliente con 4
  // contactos (medido en Chrome headless con la fuente/line-height/padding reales de `td` del
  // `.ventasTable`: 5 líneas sí crecían ~19.7px sobre 4 líneas — por eso el tope se mantiene en 4).
  // Expandido: la lista COMPLETA + "ver menos" al final (ahí sí crece, es la acción explícita del
  // usuario). Toggle clickeable, gris, mismo tamaño de fuente que los nombres (hereda de `td`).
  const renderListaContactos = (contacts, clienteId, lado, expandido) => {
    const nombreDiv = (user, idx) => (
      <div key={`${clienteId}-${lado}-${idx}`} style={{ marginBottom: "2px", paddingLeft: "10px" }}>
        {`${user.nombre} ${user.apellido}`}
      </div>
    );
    const toggleDiv = (texto) => (
      <div
        key={`${clienteId}-${lado}-toggle`}
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          toggleContactosExpandido(clienteId, lado);
        }}
        style={{
          marginBottom: "2px",
          paddingLeft: "10px",
          color: "#888",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {texto}
      </div>
    );

    if (contacts.length <= 4) return contacts.map(nombreDiv);
    if (expandido) return [...contacts.map(nombreDiv), toggleDiv("ver menos")];
    const primeros = contacts.slice(0, 3);
    const restantes = contacts.length - primeros.length;
    return [...primeros.map(nombreDiv), toggleDiv(`+${restantes} más`)];
  };

  const filtrarOportunidades = useCallback(
    () =>
      todasLasOportunidadesMemo.filter((oportunidad) => {
        const nombreIntermediario = getIntermediarioNombre(oportunidad.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteMatch = clientesMemo.find((c) => c.id === oportunidad.client_id);
        const clienteCategoria = clienteMatch ? clienteMatch.categoria : null;
        const clienteNombre = normalizarEmpresa(clienteMatch?.empresa);
        const clienteProducto = clienteMatch ? clienteMatch.producto : "";
        // Filtro "Ejecutivo": persona (id) o grupo Perú ("grupo:visiona"/"grupo:adlab").
        // Esta función itera solo PAUTA (+contratos) → matchGrupoOpp con esBTL=false.
        let matchesEjecutivo;
        if (!filtroEjecutivo) {
          matchesEjecutivo = true;
        } else if (filtroEjecutivo.startsWith("grupo:")) {
          matchesEjecutivo = matchGrupoOpp(filtroEjecutivo, oportunidad, clienteMatch, false);
        } else {
          matchesEjecutivo = clienteMatcheaEjecutivoPersona(clienteMatch, filtroEjecutivo);
        }

        // Para filtro de mes: prioridad 1 = facturafecha, prioridad 2 = mes_factura
        let mesFacturaStr = null;
        if (oportunidad.facturafecha) {
          const facturaDate = new Date(oportunidad.facturafecha);
          if (!isNaN(facturaDate.getTime())) {
            mesFacturaStr = String(facturaDate.getMonth() + 1).padStart(2, "0");
          }
        }
        if (!mesFacturaStr && oportunidad.mes_factura) {
          mesFacturaStr = oportunidad.mes_factura.split("-")[0] || null;
        }

        return (
          (!filtroCliente || clienteNombre.includes(normalizarEmpresa(filtroCliente))) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesFacturaStr && filtroMes.includes(mesFacturaStr))) &&
          // La facturación histórica (100%) SIEMPRE pasa el filtro de estatus: filtrar por
          // pipeline (90/75/50/0/sinPropuesta) no debe borrar YTD/AA/HTD ni la Facturación 2026.
          (filtroEstatus.length === 0 ||
            oportunidad.estatus === "100%" ||
            filtroEstatus.includes(oportunidad.estatus || "0%")) &&
          matchesIntermediario &&
          (filtroCategoria === "" || (clienteCategoria && parseInt(clienteCategoria) === parseInt(filtroCategoria))) &&
          matchesEjecutivo
        );
      }),
    [
      todasLasOportunidadesMemo,
      clientesMemo,
      filtroCliente,
      filtroProducto,
      filtroMes,
      filtroEstatus,
      filtroIntermediario,
      filtroCategoria,
      filtroEjecutivo,
      getIntermediarioNombre,
      matchGrupoOpp,
      clienteMatcheaEjecutivoPersona,
    ]
  );

  const filtrarOportunidadesMemo = useMemo(() => filtrarOportunidades(), [filtrarOportunidades]);
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  // getPaisCode: fuente única en src/utils/getPaisCode.js (10.1, regla 10.268) — la copia local
  // que vivía acá (`.toLowerCase()` vs `case` con mayúscula) nunca matcheaba, escondiendo
  // actividad real de 61 clientes de Chile. Ver diagnostico-crm-actividades-directas-2026-09-20.md.
  const toUpperCase = (text) => text?.toString().toUpperCase();

  // Convierte importe a la moneda usada para ordenar/comparar.
  // Si viewInUSD=true → todos los importes a USD (rate histórico).
  // Si viewInUSD=false → todos a moneda local (rate histórico, pero el callsite pasa op completa).
  // Nota: para sortear basta con que ambos lados estén en la misma moneda; usamos USD siempre.
  const convertirParaSort = useCallback(
    (op) => getImporteEnUSD(op, getDolarValue, fallbackRate),
    [getDolarValue, fallbackRate]
  );

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes) - 1] || "";
  }, []);

  const getMonedaSymbol = useCallback(() => {
    const symbols = {
      Chile: "$",
      Perú: "S/",
      Uruguay: "$",
    };
    return symbols[pais] || "$";
  }, [pais]);

  // Formato unificado vía el central useCurrency (10.1/10.27) — antes reimplementaba
  // símbolo/locale/decimales a mano (aunque ya daba USD a 0 decimales, igual que el central).
  // Perú local (PEN) preserva 2 decimales como siempre tuvo esta pantalla — formatAmount da PEN
  // a 0 por defecto, cambiarlo es un pedido aparte (fuera de alcance, ver docs/modulos/ventas-ejecutivo-v2.md).
  const formatMoneda = useCallback(
    (valor, monedaDolar = false) => {
      if (valor === null || valor === undefined || isNaN(valor)) return "-";
      if (monedaDolar) return formatAmount(valor, "USD");
      if (pais === "Perú") return formatAmount(valor, "PEN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return formatAmount(valor, "CLP");
    },
    [pais, formatAmount]
  );
  const renderProductosOptions = () => {
    // Faceted: solo productos presentes en el set filtrado (+ el seleccionado).
    const opciones =
      !filtroProducto || opcionesDinamicas.productos.includes(filtroProducto)
        ? opcionesDinamicas.productos
        : [filtroProducto, ...opcionesDinamicas.productos];
    return opciones.map((producto, index) => (
      <option key={index} value={producto || ""}>
        {producto || "Sin producto"}
      </option>
    ));
  };
  const renderUsuariosOptions = () => {
    // Proyecto Contactos, Fase 2: usa `contactosPorLado` (TODOS los contactos, sin tope de 4) en
    // vez de los 8 casilleros escalares — un contacto 5º+ tiene que poder aparecer en este dropdown
    // igual que uno de los primeros 4. Índice inverso usuario_id → empresa/agencia (primer cliente
    // encontrado, mismo criterio "el primero que matchea" que tenía el `.find()` original).
    const empresaPorUsuarioId = new Map();
    contactosPorLado.cliente.forEach((usuarioIds, clienteId) => {
      const cliente = clientes.find((c) => c.id === clienteId);
      if (!cliente) return;
      usuarioIds.forEach((uid) => {
        if (!empresaPorUsuarioId.has(uid)) empresaPorUsuarioId.set(uid, cliente.empresa);
      });
    });
    const agenciaPorUsuarioId = new Map();
    contactosPorLado.agencia.forEach((usuarioIds, clienteId) => {
      const cliente = clientes.find((c) => c.id === clienteId);
      if (!cliente) return;
      usuarioIds.forEach((uid) => {
        if (!agenciaPorUsuarioId.has(uid)) agenciaPorUsuarioId.set(uid, cliente.agencia);
      });
    });
    const idsUnicos = new Set([...empresaPorUsuarioId.keys(), ...agenciaPorUsuarioId.keys()]);

    const usuariosUnicos = [...idsUnicos]
      .filter((id) => usuarios.find((user) => user.id === id))
      .map((id) => {
        const user = usuarios.find((user) => user.id === id);
        let nombreAsociado = "";
        if (empresaPorUsuarioId.has(id)) {
          nombreAsociado = empresaPorUsuarioId.get(id);
        } else if (agenciaPorUsuarioId.has(id)) {
          nombreAsociado = getIntermediarioNombre(agenciaPorUsuarioId.get(id));
        }
        return {
          id,
          nombre: `${user.nombre} ${user.apellido}${nombreAsociado ? `, ${nombreAsociado}` : ""}`,
        };
      })
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
    // Faceted: solo usuarios (contactos) del set filtrado (+ el seleccionado).
    return usuariosUnicos
      .filter(
        (usuario) =>
          opcionesDinamicas.usuarioIds.has(String(usuario.id)) || String(usuario.id) === String(filtroUsuario)
      )
      .map((usuario, index) => (
        <option key={index} value={usuario.id}>
          {usuario.nombre}
        </option>
      ));
  };
  const isEditableByDate = (createdAt) => {
    const cutoffDate = new Date("2025-04-19");
    const createdDate = new Date(createdAt);
    if (isNaN(createdDate)) return false;
    return createdDate >= cutoffDate;
  };
  // eslint-disable-next-line no-unused-vars
  const getDaysDifference = (dateString, isFuture = false) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("-").map(Number);
    const targetDate = new Date(year, month - 1, day);
    if (isNaN(targetDate.getTime())) return "-";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffTime = targetDate - today;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (isFuture) {
      if (diffDays < 0) return "Contactar!";
      if (diffDays === 0) return "Hoy";
      if (diffDays === 1) return "Mañana";
      const todayDayOfWeek = today.getDay();
      const daysUntilSunday = todayDayOfWeek === 0 ? 0 : 7 - todayDayOfWeek;
      const endOfCurrentWeek = new Date(today);
      endOfCurrentWeek.setDate(today.getDate() + daysUntilSunday);
      const startOfNextWeek = new Date(endOfCurrentWeek);
      startOfNextWeek.setDate(endOfCurrentWeek.getDate() + 1);
      const endOfNextWeek = new Date(startOfNextWeek);
      endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
      if (targetDate >= today && targetDate <= endOfCurrentWeek) return "Esta semana";
      if (targetDate >= startOfNextWeek && targetDate <= endOfNextWeek) return "Próxima semana";
      return "15 días o más";
    } else {
      if (diffDays === 0) return "Hoy";
      if (diffDays === -1) return "Ayer";
      const todayDayOfWeek = today.getDay();
      const startOfCurrentWeek = new Date(today);
      startOfCurrentWeek.setDate(today.getDate() - (todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1));
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      if (targetDate >= startOfCurrentWeek && targetDate <= yesterday) return "Esta semana";
      const startOfLastWeek = new Date(startOfCurrentWeek);
      startOfLastWeek.setDate(startOfCurrentWeek.getDate() - 7);
      const endOfLastWeek = new Date(startOfLastWeek);
      endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
      const startOfTwoWeeksAgo = new Date(startOfLastWeek);
      startOfTwoWeeksAgo.setDate(startOfLastWeek.getDate() - 7);
      const endOfTwoWeeksAgo = new Date(startOfTwoWeeksAgo);
      endOfTwoWeeksAgo.setDate(startOfTwoWeeksAgo.getDate() + 6);
      if (targetDate >= startOfTwoWeeksAgo && targetDate <= endOfTwoWeeksAgo) return "Hace 2 semanas";
      if (targetDate >= startOfLastWeek && targetDate <= endOfLastWeek) return "Semana pasada";
      if (diffDays < -14) return "15 días o más";
      return "-";
    }
  };
  // eslint-disable-next-line no-unused-vars
  const getStatusFromText = (text, isFuture = false) => {
    if (!text || text === "-") return "default";
    const normalizedText = text.toLowerCase();
    if (isFuture) {
      if (normalizedText.startsWith("contactar!")) return "expired";
      if (normalizedText === "hoy" || normalizedText === "mañana") return "todayTomorrow";
      if (normalizedText === "esta semana") return "thisWeek";
      if (normalizedText === "próxima semana") return "nextWeek";
      if (normalizedText === "15 días o más") return "later";
    }
    return "default";
  };
  const handleMesChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMes(selectedMonths);
  }, []);
  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => {
      const monthValue = index < 9 ? `0${index + 1}` : `${index + 1}`;
      const checked = filtroMes.includes(monthValue);
      // Faceted: ocultar meses sin opps en el set filtrado (salvo los ya elegidos).
      if (!opcionesDinamicas.meses.has(monthValue) && !checked) return null;
      return (
        <div key={index} className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id={`mes${index}`}
            value={monthValue}
            checked={checked}
            onChange={handleMesChange}
            style={{ marginLeft: "-35px" }}
          />
          <label className="form-check-label" htmlFor={`mes${index}`} style={{ marginLeft: "0px" }}>
            {mes}
          </label>
        </div>
      );
    });
  const renderClientesOptions = () => {
    // Faceted: solo marcas presentes en el set filtrado (+ la seleccionada).
    const opciones =
      !filtroCliente || opcionesDinamicas.empresas.includes(filtroCliente)
        ? opcionesDinamicas.empresas
        : [filtroCliente, ...opcionesDinamicas.empresas];
    return opciones.map((empresa, index) => (
      <option key={index} value={empresa}>
        {empresa}
      </option>
    ));
  };
  const renderIntermediariosOptions = () => {
    const intermediariosFiltrados = intermediarios.filter((intermediario) => intermediario.pais === pais);
    const nombresIndividuales = [...new Set(intermediariosFiltrados.map((intermediario) => intermediario.nombre))];
    const padresUnicos = [
      ...new Set(
        nombresIndividuales.filter((nombre) => nombre.includes("|")).map((nombre) => nombre.split("|")[0].trim())
      ),
    ];
    const todasLasOpciones = [...padresUnicos, ...nombresIndividuales];
    // Faceted: solo intermediarios usados por el set filtrado (+ el seleccionado).
    const opcionesUnicasOrdenadas = [...new Set(todasLasOpciones)]
      .filter((opcion) => opcionesDinamicas.intermediarioNombres.has(opcion) || opcion === filtroIntermediario)
      .sort();
    return opcionesUnicasOrdenadas.map((opcion, index) => (
      <option key={index} value={opcion}>
        {opcion}
      </option>
    ));
  };
  const renderCategoriaClienteOptions = () =>
    ["A", "B", "C"].map((categoria, index) => {
      const checked = filtroCategoriaCliente.includes(categoria);
      // Faceted: ocultar tipos ausentes en el set filtrado (salvo los ya elegidos).
      if (!opcionesDinamicas.tipoClientes.has(categoria) && !checked) return null;
      return (
        <div key={index} className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id={`categoriaCliente${categoria}`}
            value={categoria}
            checked={checked}
            onChange={handleCategoriaClienteChange}
            style={{ marginLeft: "-35px" }}
          />
          <label className="form-check-label" htmlFor={`categoriaCliente${categoria}`} style={{ marginLeft: "0px" }}>
            {categoria}
          </label>
        </div>
      );
    });
  const handleCategoriaClienteChange = (e) => {
    const categoria = e.target.value;
    setFiltroCategoriaCliente((prev) =>
      prev.includes(categoria) ? prev.filter((c) => c !== categoria) : [...prev, categoria]
    );
  };
  const handleEstatusChange = (e) => {
    const value = e.target.value;
    setFiltroEstatus((prev) => (prev.includes(value) ? prev.filter((estatus) => estatus !== value) : [...prev, value]));
  };
  const handleFlashEdit = (oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    if (!cliente) {
      toast.error("No se encontró el cliente asociado a esta oportunidad.");
      return;
    }
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" &&
        !(cliente.ejecutivos_asignados?.includes(Number(id)) || String(id) === String(oportunidad.ejecutivo)))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    setFlashEditingOpportunity({ ...oportunidad, clienteNombre: cliente.nombre });
    setIsFlashEditing(true);
  };
  const onSubmitFlashEdit = async (updatedFields) => {
    try {
      setFlashSaving(true);
      await (flashEditingOpportunity.esContrato
        ? updateContrato({ id: flashEditingOpportunity.id, contrato: updatedFields })
        : updateOportunidad({ id: flashEditingOpportunity.id, oportunidad: updatedFields }));
      bumpVersionDatos();
      toast.success(
        flashEditingOpportunity.esContrato
          ? "Contrato actualizado correctamente"
          : "Oportunidad actualizada correctamente"
      );
      const updatedOportunidades = todasLasOportunidades.map((op) =>
        op.id === flashEditingOpportunity.id ? { ...op, ...updatedFields } : op
      );
      setTodasLasOportunidades(updatedOportunidades);
      const clienteMatch = clientes.find((c) => c.id === flashEditingOpportunity.client_id);
      if (clienteMatch) {
        const updatedClientes = clientes.map((cliente) =>
          cliente.id === flashEditingOpportunity.client_id ? { ...cliente, ...updatedFields } : cliente
        );
        setClientesPublicitarios(updatedClientes);
        const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
          updatedOportunidades,
          todasLasOportunidadesBTL,
          updatedClientes,
          CURRENT_YEAR,
          viewInUSD
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: newVentasCliente,
          ventasYTD: newVentasYTD,
          ventasAA: newVentasAA,
          ventasHTD: newVentasHTD,
        }));
      }
      setIsFlashEditing(false);
      setFlashEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setFlashSaving(false);
    }
  };
  const handleEdit = (oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    if (!cliente) {
      toast.error("No se encontró el cliente asociado a esta oportunidad.");
      return;
    }
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" &&
        !(cliente.ejecutivos_asignados?.includes(Number(id)) || String(id) === String(oportunidad.ejecutivo)))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    if (pais === "Perú" || pais === "Chile") {
      if (isEditableByDate(oportunidad.created_at)) {
        navigate(`/admin/online-cotizador/editar/${oportunidad.id}`, { state: { oportunidad } });
      } else {
        setSelectedClienteId(oportunidad.client_id);
        setSelectedOportunidadId(oportunidad.id);
        setIsModalOpen(true);
      }
    } else {
      console.warn("Edición no soportada para el país:", pais);
      toast.info("Edición no disponible para este país.");
    }
  };
  const handleEliminarOportunidad = async (oportunidad) => {
    if (oportunidad.esContrato) return;
    const confirmar = window.confirm("¿Eliminar esta oportunidad? Esta acción no se puede deshacer.");
    if (!confirmar) return;
    try {
      await updateOportunidad({ id: oportunidad.id, oportunidad: { eliminada: true } });
      bumpVersionDatos();
      setTodasLasOportunidades((prev) => prev.filter((op) => op.id !== oportunidad.id));
    } catch (error) {
      console.error("Error eliminando oportunidad:", error);
      toast.error("Error al eliminar la oportunidad");
    }
  };
  const renderEstatusOptions = () =>
    ["100%", "90%", "75%", "50%", "0%", "sinPropuesta"].map((estatus, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`estatus${index}`}
          value={estatus}
          checked={filtroEstatus.includes(estatus)}
          onChange={handleEstatusChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`estatus${index}`} style={{ marginLeft: "0px" }}>
          {estatus === "sinPropuesta" ? "Sin Propuesta" : estatus}
        </label>
      </div>
    ));
  // OCULTO TEMPORALMENTE: Función para actualizar cliente (reactivar con columnas EDIT)
  // eslint-disable-next-line no-unused-vars
  const handleUpdateCliente = async (
    clienteId,
    newEjecutivo, // Este parámetro ya no se usará
    newAgencia,
    ultimoFechaCliente,
    ultimoAccionCliente,
    proximoFechaCliente,
    proximoAccionCliente,
    ultimoFechaAgencia,
    ultimoAccionAgencia,
    proximoFechaAgencia,
    proximoAccionAgencia,
    newContactoClienteId,
    newContactoAgenciaId,
    newTipo
  ) => {
    try {
      const cliente = clientes.find((c) => c.id === clienteId);
      if (!cliente) throw new Error("Cliente no encontrado");
      const updatedData = { id: clienteId };

      // Actualizar solo si hay cambios en las fechas o acciones de contacto
      if (
        ultimoFechaCliente !== null ||
        ultimoAccionCliente !== null ||
        proximoFechaCliente !== null ||
        proximoAccionCliente !== null
      ) {
        updatedData.ultimo_contacto_fecha_cliente =
          ultimoFechaCliente instanceof Date
            ? ultimoFechaCliente.toISOString().split("T")[0]
            : ultimoFechaCliente || cliente.ultimo_contacto_fecha_cliente;
        updatedData.ultimo_contacto_accion_cliente = ultimoAccionCliente || cliente.ultimo_contacto_accion_cliente;
        updatedData.proximo_contacto_fecha_cliente =
          proximoFechaCliente instanceof Date
            ? proximoFechaCliente.toISOString().split("T")[0]
            : proximoFechaCliente || cliente.proximo_contacto_fecha_cliente;
        updatedData.proximo_contacto_accion_cliente = proximoAccionCliente || cliente.proximo_contacto_accion_cliente;
      }
      if (
        ultimoFechaAgencia !== null ||
        ultimoAccionAgencia !== null ||
        proximoFechaAgencia !== null ||
        proximoAccionAgencia !== null
      ) {
        updatedData.ultimo_contacto_fecha_agencia =
          ultimoFechaAgencia instanceof Date
            ? ultimoFechaAgencia.toISOString().split("T")[0]
            : ultimoFechaAgencia || cliente.ultimo_contacto_fecha_agencia;
        updatedData.ultimo_contacto_accion_agencia = ultimoAccionAgencia || cliente.ultimo_contacto_accion_agencia;
        updatedData.proximo_contacto_fecha_agencia =
          proximoFechaAgencia instanceof Date
            ? proximoFechaAgencia.toISOString().split("T")[0]
            : proximoFechaAgencia || cliente.proximo_contacto_fecha_agencia;
        updatedData.proximo_contacto_accion_agencia = proximoAccionAgencia || cliente.proximo_contacto_accion_agencia;
      }

      // Actualizar otros campos solo si se proporcionan, sin tocar ejecutivo ni ejecutivos_asignados
      if (newAgencia !== undefined && newAgencia !== null) updatedData.agencia = newAgencia;
      if (newContactoClienteId !== null) {
        updatedData.contactoId = newContactoClienteId;
        updatedData.contacto_cliente = newContactoClienteId;
      }
      if (newContactoAgenciaId !== null) updatedData.contacto_agencia = newContactoAgenciaId;
      if (newTipo !== "" && newTipo !== null) updatedData.categoria_cliente = newTipo;

      // Auto-detectar agencia si hay contacto agencia pero intermediario es DIRECTO o null
      const contactoAgFinal = updatedData.contacto_agencia ?? cliente.contacto_agencia;
      if (contactoAgFinal) {
        const agenciaActual = updatedData.agencia ?? cliente.agencia;
        const intermObj = intermediarios.find((i) => i.id === agenciaActual);
        const esDirectoONull = !agenciaActual || (intermObj?.nombre || "").toUpperCase() === "DIRECTO";
        if (esDirectoONull) {
          const usuarioContacto = usuarios.find((u) => u.id === contactoAgFinal);
          if (usuarioContacto?.agencia) {
            const intermDetectado = intermediarios.find((i) => i.id === usuarioContacto.agencia);
            if (intermDetectado) {
              updatedData.agencia = usuarioContacto.agencia;
              toast.success(
                `Intermediario actualizado a "${intermDetectado.nombre}" (detectado del contacto asignado)`
              );
            }
          }
        }
      }

      await updateCliente(updatedData);
      // Sincronizar contacto_agencia a la tabla relacional — escritor único (10.229), nunca borra
      // más que los 4 casilleros que ESTA pantalla tenía cargados (`antes`) vs. los que quedaron
      // (`despues`); un 5º contacto u OMNET (Mapa de Calor) quedan siempre intactos.
      if (newContactoAgenciaId !== null) {
        try {
          await sincronizarContactosCliente({
            clienteId,
            lado: "agencia",
            antes: [cliente.contacto_agencia, cliente.contacto_agencia_1, cliente.contacto_agencia_2, cliente.contacto_agencia_3],
            despues: [newContactoAgenciaId, cliente.contacto_agencia_1, cliente.contacto_agencia_2, cliente.contacto_agencia_3],
          });
        } catch (e) {
          console.error("Error sincronizando contactos agencia relacional:", e);
        }
      }
      // Sincronizar contacto_cliente a la tabla relacional — mismo escritor único.
      if (newContactoClienteId !== null) {
        try {
          await sincronizarContactosCliente({
            clienteId,
            lado: "cliente",
            antes: [cliente.contacto_cliente, cliente.contacto_cliente_1, cliente.contacto_cliente_2, cliente.contacto_cliente_3],
            despues: [newContactoClienteId, cliente.contacto_cliente_1, cliente.contacto_cliente_2, cliente.contacto_cliente_3],
          });
        } catch (e) {
          console.error("Error sincronizando contactos cliente relacional:", e);
        }
      }
      setClientesPublicitarios(
        clientes.map((cliente) => (cliente.id === clienteId ? { ...cliente, ...updatedData } : cliente))
      );
      setEditingClienteId(null);
      setEditingClienteContact(null);
      setEditingAgenciaContact(null);
      setUltimoContactoFechaCliente(null);
      setUltimoContactoAccionCliente("");
      setProximoContactoFechaCliente(null);
      setProximoContactoAccionCliente("");
      setUltimoContactoFechaAgencia(null);
      setUltimoContactoAccionAgencia("");
      setProximoContactoFechaAgencia(null);
      setProximoContactoAccionAgencia("");
      setTipoCliente("");
      toast.success("Datos guardados exitosamente");
    } catch (error) {
      console.error("Error updating cliente:", error.message);
      toast.error("Error al guardar los datos: " + error.message);
    }
  };
  const handleUpdateStatus = async (clienteId, oportunidadId, newStatus) => {
    try {
      const allowedStatuses = ["100%", "90%", "75%", "50%", "0%"];
      if (!allowedStatuses.includes(newStatus)) throw new Error("Estatus no válido");
      const oportunidad = todasLasOportunidades.find((op) => op.id === oportunidadId);
      if (!oportunidad) throw new Error("No se encontró la oportunidad para el cliente seleccionado");
      const currentYear = new Date().getFullYear().toString();
      const updateData = {
        estatus: newStatus,
        updated_at: new Date().toISOString(),
        mes_cierre:
          oportunidad.mes_cierre || `${(new Date().getMonth() + 1).toString().padStart(2, "0")}-${currentYear}`,
        mes_factura:
          oportunidad.mes_factura || `${(new Date().getMonth() + 1).toString().padStart(2, "0")}-${currentYear}`,
        ano: oportunidad.mes_factura ? parseInt(oportunidad.mes_factura.split("-")[1], 10) : parseInt(currentYear, 10),
      };
      const response = await updateOportunidad({ id: oportunidadId, oportunidad: updateData });
      if (!response || !response.data || response.data.length === 0)
        throw new Error("No se pudo actualizar la oportunidad");
      bumpVersionDatos();
      const updatedOportunidades = todasLasOportunidades.map((op) =>
        op.id === oportunidadId ? { ...op, ...updateData } : op
      );
      setTodasLasOportunidades(updatedOportunidades);
      const clienteMatch = clientes.find((c) => c.id === clienteId);
      if (clienteMatch) {
        const updatedClientes = clientes.map((cliente) =>
          cliente.id === clienteId ? { ...cliente, ...updateData } : cliente
        );
        setClientesPublicitarios(updatedClientes);
        const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
          updatedOportunidades,
          todasLasOportunidadesBTL,
          updatedClientes,
          CURRENT_YEAR,
          viewInUSD
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: newVentasCliente,
          ventasYTD: newVentasYTD,
          ventasAA: newVentasAA,
          ventasHTD: newVentasHTD,
        }));
      }
      toast.success("Estatus actualizado exitosamente");
    } catch (error) {
      console.error("Error al actualizar el estatus:", error.message);
      toast.error("Error al actualizar el estatus: " + error.message);
    }
  };

  const calcularSumasFiltradas = useCallback(
    debounce(() => {
      // Filtrar oportunidades basadas en facturafecha o mes_factura para facturación
      const filteredOportunidadesFact = filtrarOportunidadesMemo.filter((op) => {
        // Incluir si tiene facturafecha O mes_factura (igual que calcularPublicidadMensual)
        if (!op.facturafecha && !op.mes_factura) return false;
        return true;
      });
      const filteredOportunidadesBTLFact = todasLasOportunidadesBTLMemo.filter((btl) => {
        if (!btl.facturafecha && !btl.mes_factura) return false; // Incluir si tiene facturafecha O mes_factura
        const cliente = clientesMemo.find((c) => c.id === btl.client_id);
        const nombreIntermediario = getIntermediarioNombre(btl.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteNombre = cliente ? normalizarEmpresa(cliente.empresa) : "";
        const clienteProducto = cliente ? cliente.producto : "";
        const mesFacturaStr = btl.mes_factura?.split("-")?.[0] || null;
        const estatus = btl.status === 100 ? "100%" : `${btl.status || 0}%`;
        return (
          btl.pais === pais &&
          (!filtroCliente || clienteNombre.includes(normalizarEmpresa(filtroCliente))) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesFacturaStr && filtroMes.includes(mesFacturaStr))) &&
          (filtroEstatus.length === 0 || estatus === "100%" || filtroEstatus.includes(estatus)) &&
          matchesIntermediario &&
          (!filtroCategoria || (cliente && clienteCategoriaMap[btl.client_id] === filtroCategoria)) &&
          (!filtroEjecutivo ||
            (filtroEjecutivo.startsWith("grupo:")
              ? matchGrupoOpp(filtroEjecutivo, btl, cliente, true)
              : clienteMatcheaEjecutivoPersona(cliente, filtroEjecutivo)))
        );
      });

      // Filtrar oportunidades basadas en mes_cierre para cierres (sin depender del filtro mes_factura)
      const filteredOportunidadesCierre = todasLasOportunidadesMemo.filter((oportunidad) => {
        if (!oportunidad.mes_cierre) return false;
        const nombreIntermediario = getIntermediarioNombre(oportunidad.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteMatch = clientesMemo.find((c) => c.id === oportunidad.client_id);
        const clienteCategoria = clienteMatch ? clienteMatch.categoria : null;
        const clienteNombre = normalizarEmpresa(clienteMatch?.empresa);
        const clienteProducto = clienteMatch ? clienteMatch.producto : "";
        // Cierres de PAUTA: grupo → matchGrupoOpp (esBTL=false); persona → id. Guard evita NaN.
        let matchesEjecutivo;
        if (!filtroEjecutivo) {
          matchesEjecutivo = true;
        } else if (filtroEjecutivo.startsWith("grupo:")) {
          matchesEjecutivo = matchGrupoOpp(filtroEjecutivo, oportunidad, clienteMatch, false);
        } else {
          matchesEjecutivo = clienteMatcheaEjecutivoPersona(clienteMatch, filtroEjecutivo);
        }
        // Para cierres, filtrar por mes_cierre (no mes_factura)
        const mesCierreStr = oportunidad.mes_cierre?.split("-")?.[0] || null;
        return (
          (!filtroCliente || clienteNombre.includes(normalizarEmpresa(filtroCliente))) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesCierreStr && filtroMes.includes(mesCierreStr))) &&
          (filtroEstatus.length === 0 ||
            oportunidad.estatus === "100%" ||
            filtroEstatus.includes(oportunidad.estatus || "0%")) &&
          matchesIntermediario &&
          (filtroCategoria === "" || (clienteCategoria && parseInt(clienteCategoria) === parseInt(filtroCategoria))) &&
          matchesEjecutivo
        );
      });
      const filteredOportunidadesBTLCierre = todasLasOportunidadesBTLMemo.filter((btl) => {
        if (!btl.mes_cierre) return false;
        const cliente = clientesMemo.find((c) => c.id === btl.client_id);
        const nombreIntermediario = getIntermediarioNombre(btl.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteNombre = cliente ? normalizarEmpresa(cliente.empresa) : "";
        const clienteProducto = cliente ? cliente.producto : "";
        const estatus = btl.status === 100 ? "100%" : `${btl.status || 0}%`;
        // Para cierres BTL, filtrar por mes_cierre (no mes_factura)
        const mesCierreStr = btl.mes_cierre?.split("-")?.[0] || null;
        return (
          btl.pais === pais &&
          (!filtroCliente || clienteNombre.includes(normalizarEmpresa(filtroCliente))) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesCierreStr && filtroMes.includes(mesCierreStr))) &&
          (filtroEstatus.length === 0 || estatus === "100%" || filtroEstatus.includes(estatus)) &&
          matchesIntermediario &&
          (!filtroCategoria || (cliente && clienteCategoriaMap[btl.client_id] === filtroCategoria)) &&
          (!filtroEjecutivo ||
            (filtroEjecutivo.startsWith("grupo:")
              ? matchGrupoOpp(filtroEjecutivo, btl, cliente, true)
              : clienteMatcheaEjecutivoPersona(cliente, filtroEjecutivo)))
        );
      });

      // Calcular sumas con los datos filtrados
      const { sumCierres } = calculateSalesSums(
        filteredOportunidadesCierre,
        filteredOportunidadesBTLCierre,
        CURRENT_YEAR,
        1,
        12,
        pais,
        viewInUSD
      );

      const { sumaImportes100, sumaImportes90, sumaImportes75, sumaImportes50, sumaImportes0 } = calculateSalesSums(
        filteredOportunidadesFact,
        filteredOportunidadesBTLFact,
        CURRENT_YEAR,
        1,
        12,
        pais,
        viewInUSD
      );

      setSumasFiltradas({
        "100%": sumaImportes100,
        "90%": sumaImportes90,
        "75%": sumaImportes75,
        "50%": sumaImportes50,
        "0%": sumaImportes0,
      });
      setSumCierres(sumCierres);

      // Actualizar ventasPorCliente con calculateVentasYOportunidades
      const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
        filteredOportunidadesFact,
        filteredOportunidadesBTLFact,
        clientesMemo,
        CURRENT_YEAR,
        viewInUSD
      );
      setVentasData((prev) => ({
        ...prev,
        ventasPorCliente: newVentasCliente,
        ventasYTD: newVentasYTD,
        ventasAA: newVentasAA,
        ventasHTD: newVentasHTD,
      }));
    }, 300),
    [
      filtrarOportunidadesMemo,
      todasLasOportunidadesMemo,
      todasLasOportunidadesBTLMemo,
      filtroCliente,
      filtroProducto,
      filtroMes,
      filtroEstatus,
      filtroIntermediario,
      filtroCategoria,
      filtroEjecutivo,
      getIntermediarioNombre,
      pais,
      clientesMemo,
      clienteCategoriaMap,
      categorias,
      viewInUSD,
      ratesLoaded,
      matchGrupoOpp,
      clienteMatcheaEjecutivoPersona,
    ]
  );

  useEffect(() => {
    calcularSumasFiltradas();
  }, [calcularSumasFiltradas]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setErrorCargaBase(false);
        setCrmPrioridadCargada(false); // re-diferir Google Calendar hasta que la nueva oleada 1 pinte
        // [perf] temporal, quitar al cerrar la optimización de Ventas (ROADMAP_TECNICO.md)
        const perfT0Base = performance.now();
        // Estas 5 queries filtran contra clientes/intermediarios/sales/sales_btl/sales_contratos,
        // que guardan el país en formato NOMBRE ("Chile"/"Perú" — regla 10.53), no código. NO pasar
        // getPaisCode(pais) acá — eso fue exactamente la regresión del commit de centralización
        // (getPaisCode.js existe para crm_actividades/usuarios, código CHI/PER; ver la tabla en su
        // cabecera y docs/db/notas.md).
        const [
          categoriasData,
          clientesData,
          intermediariosData,
          oportunidadesData,
          usuariosData,
          oportunidadesBTLData,
          contratosRaw,
          subcategoriasData,
          contactosPorLadoData,
        ] = await Promise.all([
          getCategorias(),
          getClientes({ pais, orderBy: "nombre", ascending: true }),
          getIntermediarios({ pais }),
          getOportunidades({ pais }),
          getUsers(),
          getOportunidadesBTL({ pais }),
          getContratos({ pais }),
          getSubcategorias(),
          fetchTodosLosContactosPorLado().catch(() => ({ cliente: new Map(), agencia: new Map() })),
        ]);
        // [perf] temporal, quitar al cerrar la optimización de Ventas (ROADMAP_TECNICO.md)
        console.log(
          `[perf][CRM] ola queries base: ${Math.round(performance.now() - perfT0Base)}ms — ` +
            `clientes ${clientesData.length}, oportunidades ${oportunidadesData.length}, ` +
            `BTL ${oportunidadesBTLData.length}, contratos ${(contratosRaw || []).length}, ` +
            `usuarios ${usuariosData.length}, intermediarios ${intermediariosData.length}, ` +
            `categorias ${categoriasData.length}, subcategorias ${(subcategoriasData || []).length}, ` +
            `contactos cliente ${contactosPorLadoData.cliente.size} clientes/agencia ${contactosPorLadoData.agencia.size} clientes`
        );
        // Normalizar igual que VentasProyeccion
        const oportunidadesNoEliminadas = oportunidadesData
          .filter((oportunidad) => !oportunidad.eliminada)
          .map((oportunidad) => ({
            ...oportunidad,
            mes_cierre: normalizeMonth(oportunidad.mes_cierre, oportunidad.created_at, oportunidad.ano),
            mes_factura: normalizeMonth(oportunidad.mes_factura, oportunidad.created_at, oportunidad.ano),
          }));
        // Normalizar contratos (sales_contratos) para mergear con oportunidades
        const contratosNormalizados = (contratosRaw || [])
          .filter((c) => !c.eliminada && c.pais === pais)
          .map((c) => ({
            ...c,
            importe: Number(c.importe_total) || 0,
            esContrato: true,
            mes_cierre: normalizeMonth(c.mes_cierre, c.created_at, c.ano),
            mes_factura: c.meses?.[0]?.mes ? normalizeMonth(c.meses[0].mes, c.created_at, c.ano) : null,
            facturafecha: c.meses?.[0]?.facturafecha || null,
          }));
        setTodasLasOportunidades([...oportunidadesNoEliminadas, ...contratosNormalizados]);
        const oportunidadesBTLNoEliminadas = oportunidadesBTLData
          .filter((btl) => !btl.eliminada && btl.pais === pais)
          .map((btl) => ({
            ...btl,
            mes_cierre: normalizeMonth(btl.mes_cierre, btl.created_at, btl.ano),
            mes_factura: normalizeMonth(btl.mes_factura, btl.created_at, btl.ano),
          }));
        setTodasLasOportunidadesBTL(oportunidadesBTLNoEliminadas);
        setCategorias(categoriasData);
        setSubcategorias(subcategoriasData || []);
        const filteredClientes = clientesData;
        // viewInUSD se aplica en el useEffect dependiente de filtrarOportunidadesMemo
        const [ventasCliente, ventasYTD, ventasAA, ventasHTD] = calculateVentasYOportunidades(
          oportunidadesNoEliminadas,
          oportunidadesBTLNoEliminadas,
          filteredClientes,
          CURRENT_YEAR
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: ventasCliente,
          ventasYTD: ventasYTD,
          ventasAA: ventasAA,
          ventasHTD: ventasHTD,
        }));
        setClientesPublicitarios(filteredClientes);
        setContactosPorLado(contactosPorLadoData);
        setIntermediarios(intermediariosData);
        setUsuarios(usuariosData);
        setLoading(false);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        // Consolidar en un solo toast: getClientes/getIntermediarios/getOportunidades ya
        // muestran su propio toast.error si vuelven 0 filas (comportamiento compartido con
        // otras pantallas, no se toca) — acá se descartan y se deja uno solo, claro.
        toast.dismiss();
        toast.error("No se pudo cargar el CRM. Reintentá.");
        setErrorCargaBase(true);
        setLoading(false);
      }
    };
    fetchData();
  }, [pais, reloadTrigger]);

  // Cargar actividades CRM en bulk, priorizando clientes con oportunidades
  useEffect(() => {
    let cancelled = false;

    const cargarActividadesCRM = async () => {
      if (clientes.length === 0 || usuarios.length === 0) return;
      setLoadingCRM(true);

      try {
        const paisCode = getPaisCode(pais);
        const allClienteIds = clientes.map((c) => c.id);

        // Fase 3B paso 3 (cutover): MAIL/MEET/CALL vienen ya agrupados de
        // crm_actividad_resumen_grupos; el fallback "Último dd/mm/yy" de
        // crm_actividad_resumen_contactos. Las 2 oleadas viejas
        // (fetchAllActividadesBulk) y fetchUltimaActividadPorLado NO se disparan.
        // SALE (ventas 100% cerradas) sigue viva en el frontend — no está en la
        // tabla precalculada (docs/decisiones/2026-09-20-fase3b-diseno-actividad-
        // precalculada.md, sección 1.3) — se deriva de todasLasOportunidades, ya
        // cargado, sin fetch adicional.
        if (LEER_ACTIVIDAD_PRECALCULADA) {
          const actividadesPorCliente = {};
          allClienteIds.forEach((id) => {
            actividadesPorCliente[id] = [];
          });
          todasLasOportunidades
            .filter((op) => op.estatus === "100%" && op.fecha_cierre && actividadesPorCliente[op.client_id])
            .forEach((op) => {
              actividadesPorCliente[op.client_id].push({
                id: op.esContrato ? `sale-contrato-${op.id}` : `sale-${op.id}`,
                tipo: "SALE",
                fecha: op.fecha_cierre,
                cliente_id: op.client_id,
                destinatarios: [],
                estatus: op.estatus,
                fecha_cierre: op.fecha_cierre,
                excluir_broker: op.excluir_broker,
                metadata: {
                  sale_id: op.id,
                  importe: op.importe,
                  campana: op.campana,
                  code: op.esContrato ? op.display_id : op.code,
                  esContrato: op.esContrato || undefined,
                },
                virtual: true,
              });
            });

          const [grupos, contactos, ultimoCalculo] = await Promise.all([
            fetchResumenGrupos(allClienteIds),
            fetchResumenContactos(allClienteIds),
            fetchUltimoCalculo(),
          ]);

          const gruposPorCliente = {};
          grupos.forEach((g) => {
            if (!gruposPorCliente[g.cliente_id]) gruposPorCliente[g.cliente_id] = { agencia: [], cliente: [] };
            gruposPorCliente[g.cliente_id][g.lado].push(g);
          });

          const ultimasPorCliente = {};
          contactos.forEach((c) => {
            if (!ultimasPorCliente[c.cliente_id]) ultimasPorCliente[c.cliente_id] = { agencia: null, cliente: null };
            const actual = ultimasPorCliente[c.cliente_id][c.lado];
            if (!actual || c.ultima_fecha > actual) ultimasPorCliente[c.cliente_id][c.lado] = c.ultima_fecha;
          });

          if (!cancelled) {
            setActividadesCRM(actividadesPorCliente);
            setGruposActividadCRM(gruposPorCliente);
            setUltimaActividadPorLado(ultimasPorCliente);
            setActividadCalculadoAt(ultimoCalculo);
            setCrmPrioridadCargada(true); // habilitar Google Calendar (no compite)
            setLoadingCRM(false);
          }
          return;
        }

        // Proyecto Contactos, Fase 2: contactIds de TODOS los contactos por lado (sin tope de 4),
        // `contactosPorLado` (fuente única, 10.229) — ya no `buildContactMap(clientes, usuarios)`,
        // que además nunca leía la relacional del lado cliente (siempre legacy) ni excluía OMNET.
        const emailByUserId = new Map();
        usuarios.forEach((u) => {
          if (u.email) emailByUserId.set(u.id, u.email.toLowerCase());
        });
        const contactMap = {};
        clientes.forEach((cliente) => {
          const agenciaIds = contactosPorLado.agencia.get(cliente.id) || [];
          const clienteIds = contactosPorLado.cliente.get(cliente.id) || [];
          const userIds = [...new Set([...agenciaIds, ...clienteIds])];
          const emails = userIds.map((uid) => emailByUserId.get(uid)).filter(Boolean);
          contactMap[cliente.id] = { userIds, emails };
        });

        // Determinar clientes con oportunidades (aparecen primero en la tabla)
        const clientesConOportunidades = new Set();
        [...todasLasOportunidades, ...todasLasOportunidadesBTL].forEach((op) => {
          if (op.client_id && allClienteIds.includes(op.client_id)) {
            clientesConOportunidades.add(op.client_id);
          }
        });

        const priorityIds = allClienteIds.filter((id) => clientesConOportunidades.has(id));
        const restIds = allClienteIds.filter((id) => !clientesConOportunidades.has(id));

        // Última actividad histórica por lado (para fallback "Último dd/mm/yy"), en paralelo.
        // contactIds resueltos desde `contactosPorLado` — mismo helper que usa el render, sin
        // tope de 4 (Fase 2).
        const contactMapPorCliente = {};
        clientes.forEach((c) => {
          contactMapPorCliente[c.id] = {
            agencia: contactosPorLado.agencia.get(c.id) || [],
            cliente: contactosPorLado.cliente.get(c.id) || [],
          };
        });
        const ultimasPromise = fetchUltimaActividadPorLado(paisCode, contactMapPorCliente).catch((e) => {
          log.error("fetchUltimaActividadPorLado", e);
          return {};
        });

        // Oleada 1: clientes con oportunidades (top de la tabla)
        let actividadesPorCliente = {};
        let ultimasResueltas = {};
        if (priorityIds.length > 0) {
          const priorityContactMap = {};
          priorityIds.forEach((id) => {
            priorityContactMap[id] = contactMap[id];
          });
          // [perf] temporal, quitar al cerrar la optimización de Ventas (ROADMAP_TECNICO.md)
          const perfT0Prio = performance.now();
          const [prioAct, ultimas] = await Promise.all([
            fetchAllActividadesBulk(paisCode, priorityIds, priorityContactMap, 100, "CRM·prio"),
            ultimasPromise,
          ]);
          // [perf] temporal — incluye fetchUltimaActividadPorLado (corre en paralelo con la oleada 1)
          console.log(
            "[perf][CRM] ola actividades (oleada 1 · prioritarios): " +
              `${Math.round(performance.now() - perfT0Prio)}ms — ${priorityIds.length} clientes con oportunidades`
          );
          actividadesPorCliente = prioAct;
          ultimasResueltas = ultimas;
          if (!cancelled) {
            setActividadesCRM({ ...actividadesPorCliente });
            setUltimaActividadPorLado(ultimas);
            setLoadingCRM(false);
            setCrmPrioridadCargada(true); // oleada 1 pintó → habilitar Google Calendar (no compite)
          }
        } else if (!cancelled) {
          // Sin clientes prioritarios: igual dejar lista la última-actividad antes de oleada 2
          ultimasResueltas = await ultimasPromise;
          setUltimaActividadPorLado(ultimasResueltas);
          setCrmPrioridadCargada(true); // sin prioritarios: habilitar Google Calendar igual
        }

        // Oleada 2: clientes sin oportunidades
        if (restIds.length > 0 && !cancelled) {
          const restContactMap = {};
          restIds.forEach((id) => {
            restContactMap[id] = contactMap[id];
          });
          // [perf] temporal, quitar al cerrar la optimización de Ventas (ROADMAP_TECNICO.md)
          const perfT0Rest = performance.now();
          // incluirVentas=false: los restIds son clientes SIN oportunidades → no tienen ventas 100%
          // (verificado en DB), así que se saltan las 2 queries de sales/contratos (siempre 0).
          const restActividades = await fetchAllActividadesBulk(
            paisCode,
            restIds,
            restContactMap,
            100,
            "CRM·rest",
            false
          );
          // [perf] temporal
          console.log(
            "[perf][CRM] ola actividades (oleada 2 · restIds): " +
              `${Math.round(performance.now() - perfT0Rest)}ms — ${restIds.length} clientes sin oportunidades`
          );
          actividadesPorCliente = { ...actividadesPorCliente, ...restActividades };
          if (!cancelled) setActividadesCRM(actividadesPorCliente);
        }

        // Rellenar clientes sin actividades con array vacío
        allClienteIds.forEach((id) => {
          if (!actividadesPorCliente[id]) actividadesPorCliente[id] = [];
        });
        if (!cancelled) setActividadesCRM(actividadesPorCliente);

        // Fase 3B, paso 2 (dual-run): lee las tablas nuevas EN PARALELO y compara con [dualrun],
        // sin bloquear el render (fire-and-forget, después de que el camino viejo ya resolvió).
        // No cambia nada de lo pintado. Se retira completo en el paso 3.
        if (DUAL_RUN_ACTIVIDADES && !cancelled) {
          compararDualRunCRM({
            clientes,
            actividadesCRM: actividadesPorCliente,
            ultimaActividadPorLado: ultimasResueltas,
            paisCode,
            usuarios,
          });
        }
      } catch (error) {
        log.error("cargarActividadesCRM", error);
        if (!cancelled) {
          const emptyResult = {};
          clientes.forEach((c) => {
            emptyResult[c.id] = [];
          });
          setActividadesCRM(emptyResult);
        }
      } finally {
        if (!cancelled) setLoadingCRM(false);
      }
    };

    cargarActividadesCRM();
    return () => {
      cancelled = true;
    };
  }, [clientes, usuarios, todasLasOportunidades, todasLasOportunidadesBTL, pais, contactosPorLado]);

  useEffect(() => {
    calcularSumasFiltradas();
  }, [calcularSumasFiltradas]);

  useEffect(() => {
    const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
      filtrarOportunidadesMemo,
      todasLasOportunidadesBTLMemo,
      clientesMemo,
      CURRENT_YEAR,
      viewInUSD
    );
    setVentasData((prev) => ({
      ...prev,
      ventasPorCliente: newVentasCliente,
      ventasYTD: newVentasYTD,
      ventasAA: newVentasAA,
      ventasHTD: newVentasHTD,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrarOportunidadesMemo, todasLasOportunidadesBTLMemo, clientesMemo, viewInUSD, ratesLoaded]);

  const getContactoPriority = (
    cliente,
    today,
    todayDate,
    tomorrowDate,
    startOfCurrentWeek,
    endOfCurrentWeek,
    startOfNextWeek,
    endOfNextWeek,
    fifteenDaysFromNow
  ) => {
    const proximoContactoCliente = parseLocalDate(cliente.proximo_contacto_fecha_cliente);
    const proximoContactoAgencia = parseLocalDate(cliente.proximo_contacto_fecha_agencia);
    let proximoContactoDate = proximoContactoCliente;
    if (proximoContactoAgencia && (!proximoContactoCliente || proximoContactoAgencia < proximoContactoCliente)) {
      proximoContactoDate = proximoContactoAgencia;
    } else if (!proximoContactoCliente && !proximoContactoAgencia) return 999;
    if (!proximoContactoDate || isNaN(proximoContactoDate.getTime())) return 999;
    if (proximoContactoDate < today) return 1;
    if (
      proximoContactoDate.getFullYear() === todayDate.getFullYear() &&
      proximoContactoDate.getMonth() === todayDate.getMonth() &&
      proximoContactoDate.getDate() === todayDate.getDate()
    )
      return 2;
    if (
      proximoContactoDate.getFullYear() === tomorrowDate.getFullYear() &&
      proximoContactoDate.getMonth() === tomorrowDate.getMonth() &&
      proximoContactoDate.getDate() === tomorrowDate.getDate()
    )
      return 3;
    if (
      proximoContactoDate >= startOfCurrentWeek &&
      proximoContactoDate <= endOfCurrentWeek &&
      proximoContactoDate >= today
    )
      return 4;
    if (proximoContactoDate >= startOfNextWeek && proximoContactoDate <= endOfNextWeek) return 5;
    if (proximoContactoDate >= fifteenDaysFromNow) return 6;
    return 7;
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayDate = new Date(today);
  const tomorrowDate = new Date(today);
  tomorrowDate.setDate(today.getDate() + 1);
  const todayDayOfWeek = today.getDay();
  const startOfCurrentWeek = new Date(today);
  startOfCurrentWeek.setDate(today.getDate() - (todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1));
  const endOfCurrentWeek = new Date(startOfCurrentWeek);
  endOfCurrentWeek.setDate(startOfCurrentWeek.getDate() + 6);
  const startOfNextWeek = new Date(startOfCurrentWeek);
  startOfNextWeek.setDate(startOfCurrentWeek.getDate() + 7);
  const endOfNextWeek = new Date(startOfNextWeek);
  endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
  const fifteenDaysFromNow = new Date(today);
  fifteenDaysFromNow.setDate(today.getDate() + 15);
  // eslint-disable-next-line no-unused-vars
  const mapOrdenamientoToText = (value) =>
    ({
      contactar: "Contactar!",
      hoy: "Hoy",
      mañana: "Mañana",
      estaSemana: "Esta semana",
      proximaSemana: "Próxima semana",
      mas15Dias: "15 días o más",
    })[value] || "";
  const renderEjecutivosOptions = () => {
    const countryMapping = { Uruguay: "URU", Perú: "PER", Chile: "CHI" };
    const countryCode = countryMapping[pais] || "";
    const ejecutivosUnicos = usuarios
      .filter((user) => {
        const userPais = user.pais || "";
        const userRol = user.rol ? user.rol.toLowerCase().trim() : "";
        const validRoles = ["comercial", "gerencia"].map((r) => r.toLowerCase());
        return (userPais === countryCode || !countryCode) && validRoles.includes(userRol) && user.habilitado === true;
      })
      // Faceted: solo ejecutivos presentes en el set filtrado (+ el seleccionado).
      .filter(
        (user) => opcionesDinamicas.ejecutivoIds.has(String(user.id)) || String(user.id) === String(filtroEjecutivo)
      )
      .sort((a, b) => `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`));
    return ejecutivosUnicos.map((usuario, index) => (
      <option key={index} value={usuario.id}>
        {`${usuario.nombre} ${usuario.apellido}`}
      </option>
    ));
  };
  const getRadius = (key, data) => {
    const keys = Object.keys(data).filter((key) => data[key] > 0);
    const firstKey = keys[0];
    const lastKey = keys.at(-1);
    if (firstKey === key && lastKey === key) return [10, 10, 10, 10];
    else if (firstKey === key) return [10, 0, 0, 10];
    else if (lastKey === key) return [0, 10, 10, 0];
    return [0, 0, 0, 0];
  };
  const getBootstrapClassForStatus = (status) => {
    switch (status) {
      case "100%":
        return "bg-success";
      case "90%":
        return "bg-danger";
      case "75%":
        return "bg-primary";
      case "50%":
        return "bg-warning";
      case "0%":
        return "bg-black";
      default:
        return "bg-secondary";
    }
  };
  const getColorForStatus = (status) => {
    switch (status) {
      case "100%":
        return "#198754";
      case "90%":
        return "#dc3545";
      case "75%":
        return "#0d6efd";
      case "50%":
        return "#ffc107";
      case "0%":
        return "#000000";
      default:
        return "#555555";
    }
  };
  const getLabelColorForStatus = (status) => (status === "50%" ? "#000" : "#fff");
  useEffect(() => {
    const newData = [
      {
        name: "Total",
        "100%": (sumasFiltradas["100%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "90%": (sumasFiltradas["90%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "75%": (sumasFiltradas["75%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "50%": (sumasFiltradas["50%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "0%": (sumasFiltradas["0%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        empty: Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) === 0 ? 100 : 0,
      },
    ];
    setData(newData);
  }, [sumasFiltradas]);
  // ── Cross-filtering (faceted search) ──
  // Conjunto base de clientes que pasan TODOS los filtros activos, SIN ordenar.
  // Fuente única compartida por las filas (filtrarClientes lo reutiliza) y por las
  // opciones dinámicas de los dropdowns → filas y opciones nunca divergen.
  // (matchesProximoContacto se omite: ordenamiento.porFecha siempre es "null" → true.)
  const clientesFiltradosBase = useMemo(
    () =>
      clientes.filter((cliente) => {
        const nombreAgencia = getIntermediarioNombre(cliente.agencia);
        const matchesAgencia =
          filtroIntermediario === "" ||
          nombreAgencia === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreAgencia.startsWith(`${filtroIntermediario} |`));
        const clienteMatch = !filtroCliente || normalizarEmpresa(cliente.empresa).includes(normalizarEmpresa(filtroCliente));
        const productoMatch = !filtroProducto || cliente.producto === filtroProducto;
        const categoriaClienteMatch =
          filtroCategoriaCliente.length === 0 || filtroCategoriaCliente.includes(cliente.categoria_cliente);
        const categoriaMatch =
          filtroCategoria === "" || (cliente.categoria && parseInt(cliente.categoria) === parseInt(filtroCategoria));
        const subcategoriaMatch = !filtroSubcategoria || String(cliente.subcategoria_id) === String(filtroSubcategoria);
        const mesMatch =
          filtroMes.length === 0 ||
          [...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
            (op) => op.client_id === cliente.id && filtroMes.includes(op.mes_factura?.split("-")?.[0] || "01")
          );
        const estatusMatch =
          filtroEstatus.length === 0 ||
          (filtroEstatus.includes("sinPropuesta") &&
            ![...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
              (op) =>
                op.client_id === cliente.id &&
                (op.estatus === "90%" ||
                  op.estatus === "75%" ||
                  op.estatus === "50%" ||
                  (op.status < 100 && op.status > 0))
            )) ||
          [...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
            (op) => op.client_id === cliente.id && filtroEstatus.includes(op.estatus || `${op.status}%`)
          );
        // Proyecto Contactos, Fase 2: contra `contactosPorLado` (TODOS los contactos), no los 8
        // casilleros escalares — un cliente con el contacto buscado solo en el 5º+ lugar tiene que
        // matchear igual.
        const usuarioMatch =
          !filtroUsuario ||
          [...(contactosPorLado.cliente.get(cliente.id) || []), ...(contactosPorLado.agencia.get(cliente.id) || [])].some(
            (uid) => String(uid) === String(filtroUsuario)
          );
        // Filtro "Ejecutivo": persona (id) o grupo Perú ("grupo:visiona"/"grupo:adlab").
        // Pertenencia de fila PER-CUENTA por `broker_id` actual (`esBrokerAdLab`), sin excepción
        // por fecha: la cuenta ENTERA va a AdLab si `broker_id===115`, a Visiona si no. No depende
        // de que la cuenta tenga oportunidades (una cuenta AdLab sin opps igual aparece en AdLab).
        // Partición exacta: AdLab ∪ Visiona = todas, AdLab ∩ Visiona = ∅ (nunca partida).
        let matchesEjecutivo;
        if (!filtroEjecutivo) {
          matchesEjecutivo = true;
        } else if (filtroEjecutivo === "grupo:adlab") {
          matchesEjecutivo = esBrokerAdLab(cliente);
        } else if (filtroEjecutivo === "grupo:visiona") {
          matchesEjecutivo = !esBrokerAdLab(cliente);
        } else if (filtroEjecutivo.startsWith("grupo:")) {
          matchesEjecutivo = true; // grupo desconocido → pass-through
        } else {
          matchesEjecutivo = clienteMatcheaEjecutivoPersona(cliente, filtroEjecutivo);
        }
        return (
          clienteMatch &&
          productoMatch &&
          categoriaMatch &&
          subcategoriaMatch &&
          categoriaClienteMatch &&
          matchesAgencia &&
          mesMatch &&
          estatusMatch &&
          usuarioMatch &&
          matchesEjecutivo
        );
      }),
    [
      clientes,
      filtroCliente,
      filtroProducto,
      filtroCategoria,
      filtroCategoriaCliente,
      filtroSubcategoria,
      filtroIntermediario,
      filtroMes,
      filtroEstatus,
      filtroUsuario,
      filtroEjecutivo,
      todasLasOportunidades,
      todasLasOportunidadesBTL,
      getIntermediarioNombre,
      esBrokerAdLab,
      clienteMatcheaEjecutivoPersona,
      contactosPorLado,
    ]
  );

  // Opciones válidas para cada dropdown, derivadas del conjunto ya filtrado. Cada
  // render de opciones intersecta su lista con estos sets (+ la opción seleccionada,
  // para poder deseleccionarla). Status queda fijo (constante), no se facetea.
  const opcionesDinamicas = useMemo(() => {
    const idsBase = new Set(clientesFiltradosBase.map((c) => c.id));
    const oppsBase = [...todasLasOportunidades, ...todasLasOportunidadesBTL].filter((op) => idsBase.has(op.client_id));
    const intermediarioNombres = new Set();
    const usuarioIds = new Set();
    clientesFiltradosBase.forEach((c) => {
      if (c.agencia) {
        const nombre = getIntermediarioNombre(c.agencia);
        if (nombre) {
          intermediarioNombres.add(nombre);
          if (nombre.includes("|")) intermediarioNombres.add(nombre.split("|")[0].trim());
        }
      }
      // Proyecto Contactos, Fase 2: `contactosPorLado` (TODOS los contactos), no los 8 casilleros.
      [...(contactosPorLado.cliente.get(c.id) || []), ...(contactosPorLado.agencia.get(c.id) || [])].forEach(
        (uid) => {
          usuarioIds.add(String(uid));
        }
      );
    });
    return {
      empresas: [...new Set(clientesFiltradosBase.map((c) => c.empresa).filter(Boolean))].sort((a, b) =>
        a.localeCompare(b)
      ),
      productos: [...new Set(clientesFiltradosBase.map((c) => c.producto).filter(Boolean))].sort((a, b) =>
        a.localeCompare(b)
      ),
      ejecutivoIds: new Set(
        clientesFiltradosBase.map((c) => String(c.ejecutivo)).filter((x) => x && x !== "null" && x !== "undefined")
      ),
      categoriaIds: new Set(
        clientesFiltradosBase
          .map((c) => c.categoria)
          .filter((x) => x != null)
          .map(String)
      ),
      subcategoriaIds: new Set(
        clientesFiltradosBase
          .map((c) => c.subcategoria_id)
          .filter((x) => x != null)
          .map(String)
      ),
      tipoClientes: new Set(clientesFiltradosBase.map((c) => c.categoria_cliente).filter(Boolean)),
      meses: new Set(oppsBase.map((op) => op.mes_factura?.split("-")?.[0]).filter(Boolean)),
      intermediarioNombres,
      usuarioIds,
    };
  }, [clientesFiltradosBase, todasLasOportunidades, todasLasOportunidadesBTL, getIntermediarioNombre, contactosPorLado]);

  // Flash form state ahora se maneja dentro de FlashEditModal
  const parseLocalDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const filtrarClientes = useCallback(() => {
    // Reutiliza el conjunto ya filtrado (fuente única compartida con los dropdowns).
    // Solo aplica el ordenamiento a continuación.
    let filteredClientes = [...clientesFiltradosBase];
    if (ordenPorAntiguedad) {
      // Orden por antigüedad de oportunidad. Fecha-representante del cliente:
      // asc → su opp MÁS ANTIGUA (min), desc → su opp MÁS RECIENTE (max). Ignora
      // opps sin fecha válida; clientes sin ninguna fecha → al final (ambos sentidos).
      const fechaRepresentante = (clienteId) => {
        const tiempos = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === clienteId)
          .map((op) => getOportunidadRefDate(op))
          .filter(Boolean)
          .map((d) => d.getTime());
        if (tiempos.length === 0) return null;
        return ordenPorAntiguedad === "asc" ? Math.min(...tiempos) : Math.max(...tiempos);
      };
      return filteredClientes.sort((a, b) => {
        const fa = fechaRepresentante(a.id);
        const fb = fechaRepresentante(b.id);
        if (fa === null && fb === null) return (a.empresa || "").localeCompare(b.empresa || "");
        if (fa === null) return 1; // sin fecha → al final
        if (fb === null) return -1;
        return ordenPorAntiguedad === "asc" ? fa - fb : fb - fa;
      });
    }
    filteredClientes = filteredClientes.sort((a, b) => {
      const oportunidades90A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "90%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades90B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "90%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades90A !== oportunidades90B) return oportunidades90B - oportunidades90A;
      const oportunidades75A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "75%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades75B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "75%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades75A !== oportunidades75B) return oportunidades75B - oportunidades75A;
      const oportunidades50A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "50%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades50B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "50%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades50A !== oportunidades50B) return oportunidades50B - oportunidades50A;
      const oportunidades100A = ventasData.ventasPorCliente[a.id] || 0;
      const oportunidades100B = ventasData.ventasPorCliente[b.id] || 0;
      if (oportunidades100A !== oportunidades100B) return oportunidades100B - oportunidades100A;
      const oportunidades0A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "0%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades0B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "0%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades0A !== oportunidades0B) return oportunidades0B - oportunidades0A;
      const dateA =
        parseLocalDate(a.proximo_contacto_fecha_cliente) || parseLocalDate(a.proximo_contacto_fecha_agencia);
      const dateB =
        parseLocalDate(b.proximo_contacto_fecha_cliente) || parseLocalDate(b.proximo_contacto_fecha_agencia);
      if (dateA && dateB && dateA.getTime() !== dateB.getTime()) {
        const priorityA = getContactoPriority(
          a,
          today,
          todayDate,
          tomorrowDate,
          startOfCurrentWeek,
          endOfCurrentWeek,
          startOfNextWeek,
          endOfNextWeek,
          fifteenDaysFromNow
        );
        const priorityB = getContactoPriority(
          b,
          today,
          todayDate,
          tomorrowDate,
          startOfCurrentWeek,
          endOfCurrentWeek,
          startOfNextWeek,
          endOfNextWeek,
          fifteenDaysFromNow
        );
        if (priorityA !== priorityB) return priorityA - priorityB;
        return dateA - dateB;
      }
      return (a.empresa || "").localeCompare(b.empresa || "");
    });
    return filteredClientes;
  }, [
    clientesFiltradosBase,
    ordenPorAntiguedad,
    todasLasOportunidades,
    todasLasOportunidadesBTL,
    ventasData.ventasPorCliente,
    today,
    todayDate,
    tomorrowDate,
    startOfCurrentWeek,
    endOfCurrentWeek,
    startOfNextWeek,
    endOfNextWeek,
    fifteenDaysFromNow,
    convertirParaSort,
    getContactoPriority,
  ]);

  const filtersContent = (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "16px" }}>
      <div className={s.filtersContainer} style={{ flex: 1 }}>
        {/* Fila 1: Ejecutivo, Marca, Producto, Mes/meses, Status */}
        <div className={s.filterRow}>
          <div>
            <select
              className={`form-control ${filtroEjecutivo ? s.activeFilter : ""}`}
              value={filtroEjecutivo || ""}
              onChange={(e) => setFiltroEjecutivo(e.target.value)}
            >
              <option value="">Ejecutivo</option>
              {/* Perú: agrupaciones Visiona/AdLab arriba de las personas. Fuera del intersect
                  faceteado (opcionesDinamicas.ejecutivoIds) → siempre visibles. Chile sin cambios. */}
              {pais === "Perú" && (
                <>
                  <option value="grupo:visiona">Visiona</option>
                  <option value="grupo:adlab">AdLab</option>
                </>
              )}
              {renderEjecutivosOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroCliente ? s.activeFilter : ""}`}
              value={filtroCliente || ""}
              onChange={(e) => onChangeEmpresa(e.target.value)}
              disabled={empresaDisabled}
              style={empresaDisabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
            >
              <option value="">{empresaDisabled ? empresasDeProducto[0] : "Marca"}</option>
              {renderClientesOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroProducto ? s.activeFilter : ""}`}
              value={filtroProducto || ""}
              onChange={(e) => onChangeProducto(e.target.value)}
              disabled={productoDisabled}
              style={productoDisabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
            >
              <option value="">{productoDisabled ? productosDeEmpresa[0] : "Producto"}</option>
              {renderProductosOptions()}
            </select>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-basic"
                className={`form-control text-start ${filtroMes.length > 0 ? s.activeFilter : ""}`}
              >
                {filtroMes.length > 0 ? filtroMes.map((mes) => mesEnLetras(mes)).join(", ") : "Mes/meses"}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderMesOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-status"
                className={`form-control text-start ${filtroEstatus.length > 0 ? s.activeFilter : ""}`}
              >
                {filtroEstatus.length > 0 ? filtroEstatus.join(", ") : "Status"}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderEstatusOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {/* Fila 2: Categoría, Intermediario, Próximo Contacto, Usuario, Tipo Cliente */}
        <div className={s.filterRow}>
          <CategoriaSubcategoriaFilter
            categorias={categorias.filter(
              (c) => opcionesDinamicas.categoriaIds.has(String(c.id)) || String(c.id) === String(filtroCategoria)
            )}
            subcategorias={subcategorias.filter(
              (sc) =>
                opcionesDinamicas.subcategoriaIds.has(String(sc.id)) || String(sc.id) === String(filtroSubcategoria)
            )}
            filtroCategoria={filtroCategoria}
            filtroSubcategoria={filtroSubcategoria}
            onCategoriaChange={setFiltroCategoria}
            onSubcategoriaChange={setFiltroSubcategoria}
            className="form-control"
            activeClass={s.activeFilter}
          />
          <div>
            <select
              className={`form-control ${filtroIntermediario ? s.activeFilter : ""}`}
              value={filtroIntermediario}
              onChange={(e) => setFiltroIntermediario(e.target.value)}
            >
              <option value="">Intermediario</option>
              {renderIntermediariosOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroUsuario ? s.activeFilter : ""}`}
              value={filtroUsuario || ""}
              onChange={(e) => setFiltroUsuario(e.target.value)}
            >
              <option value="">Usuario</option>
              {renderUsuariosOptions()}
            </select>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-categoria-cliente"
                className={`form-control text-start ${filtroCategoriaCliente.length > 0 ? s.activeFilter : ""}`}
              >
                {filtroCategoriaCliente.length > 0 ? filtroCategoriaCliente.join(", ") : "Tipo Cliente"}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderCategoriaClienteOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      {/* Marca discreta de la corrida del cron que alimenta la actividad precalculada (Fase 3B
          paso 3). Si nunca corrió (calculado_at null tras terminar de cargar), lo dice — no se
          queda en blanco en silencio (10.177). */}
      {LEER_ACTIVIDAD_PRECALCULADA && !loadingCRM && (
        <span style={{ fontSize: "0.72rem", color: "#999", whiteSpace: "nowrap", marginRight: "8px" }}>
          {actividadCalculadoAt
            ? `Actividad actualizada ${new Date(actividadCalculadoAt).toLocaleTimeString("es-CL", {
                hour: "2-digit",
                minute: "2-digit",
              })}`
            : "Actividad: el cálculo automático todavía no corrió"}
        </span>
      )}
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          whiteSpace: "nowrap",
          marginRight: "16px",
          cursor: "pointer",
          fontSize: "0.85rem",
          color: "#000",
        }}
      >
        Ver en dólares
        <input
          type="checkbox"
          checked={viewInUSD}
          onChange={(e) => setViewInUSD(e.target.checked)}
          disabled={!ratesLoaded}
        />
      </label>
    </div>
  );

  // Publica los filtros en el header del shell (hook incondicional — no hay early return antes de
  // este punto). Fuera del hub (sin tabKey) es un no-op y se usa el renderHeader/fallback de
  // siempre, más abajo — y el header queda visible SIEMPRE (error, cargando o con datos), ya no
  // depende de llegar a la rama "con datos" del ternario de abajo.
  useHubHeaderFilters(tabKey, filtersContent);

  return (
    <div>
      {tabKey ? null : renderHeader ? renderHeader(filtersContent) : filtersContent}
      {errorCargaBase && !loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "80px 20px",
            gap: "16px",
          }}
        >
          <div style={{ fontSize: "1rem", color: "#555" }}>No se pudo cargar el CRM.</div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setReloadTrigger((n) => n + 1)}
          >
            Reintentar
          </button>
        </div>
      ) : loading ? (
        // Estado de carga honesto (10.177): loader simple, nunca el "sin datos" de la tabla real.
        <div style={{ minHeight: 300 }}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={`mb-2 ${styles.cardsContainer}`}>
            <div className="d-flex justify-content-between">
              <div
                className="text-center p-2 border border-dark m-3 text-white"
                style={{ borderRadius: "5px", width: "200px", backgroundColor: "#6318a9ff" }}
              >
                <div>
                  <strong>Cierres {CURRENT_YEAR}</strong>
                </div>
                <div>{sumCierres > 0 ? formatMoneda(sumCierres, viewInUSD) : "-"}</div>
              </div>
              {["100%", "90%", "75%", "50%", "0%"].map((estatus, index) => (
                <div
                  key={index}
                  className={`text-center p-2 ${getBootstrapClassForStatus(estatus)} border border-dark m-3 text-${
                    estatus === "50%" ? "dark" : "white"
                  }`}
                  style={{ borderRadius: "5px", width: "200px" }}
                >
                  <div>
                    <strong>{estatus === "100%" ? `Facturación ${CURRENT_YEAR}` : estatus}</strong>
                  </div>
                  <div>{sumasFiltradas[estatus] > 0 ? formatMoneda(sumasFiltradas[estatus], viewInUSD) : "-"}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.chartContainer}>
            <ResponsiveContainer width="100%" height={80} className="p-0 m-0">
              <BarChart layout="vertical" data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                <XAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
                <YAxis type="category" dataKey="name" hide />
                {data[0].empty > 0 ? (
                  <Bar dataKey="empty" fill="#555555" isAnimationActive={false} radius={[10, 10, 10, 10]}>
                    <LabelList
                      dataKey="empty"
                      position="center"
                      formatter={() => "Sin propuestas asociadas :("}
                      fill="#FFF"
                    />
                  </Bar>
                ) : (
                  ["100%", "90%", "75%", "50%", "0%"].map(
                    (estatus) =>
                      data[0][estatus] > 0 && (
                        <Bar
                          key={estatus}
                          dataKey={estatus}
                          stackId="a"
                          fill={getColorForStatus(estatus)}
                          radius={getRadius(estatus, data[0])}
                        >
                          <LabelList
                            dataKey={estatus}
                            position="center"
                            formatter={(value) => `${Math.round(value)}%`}
                            fill={getLabelColorForStatus(estatus)}
                          />
                        </Bar>
                      )
                  )
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <table id="ventas-table" className={`${styles.ventasTable} table table-bordered`}>
            <thead>
              <tr>
                <th rowSpan={2} className="text-center col-cliente">
                  {toUpperCase("CLIENTE/PROSPECT")}
                </th>
                <th rowSpan={2} className="text-center col-contacto">
                  {toUpperCase("CONTACTO")}
                </th>
                <th
                  rowSpan={2}
                  className="text-center col-oportunidad"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={cycleOrdenAntiguedad}
                  title={
                    ordenPorAntiguedad === "asc"
                      ? "Antigüedad: más antigua primero (clic → más reciente)"
                      : ordenPorAntiguedad === "desc"
                        ? "Antigüedad: más reciente primero (clic → orden default)"
                        : "Ordenar por antigüedad (clic → más antigua primero)"
                  }
                >
                  {toUpperCase("OPORTUNIDADES")}
                  {ordenPorAntiguedad === "asc" ? " ↑" : ordenPorAntiguedad === "desc" ? " ↓" : ""}
                </th>
                <th rowSpan={2} className="text-center col-mov-futuros">
                  {toUpperCase("AGENDA")}
                  <br />
                  {toUpperCase("FUTURA")}
                </th>
                <th rowSpan={2} className="text-center col-actividad">
                  {toUpperCase("ACTIVIDAD RECIENTE")}
                </th>
                {/* OCULTO: PRÓXIMO CONTACTO
                <th rowSpan={2} colSpan="2" className="text-center col-proximo">
                  {toUpperCase("PRÓXIMO CONTACTO")}
                </th>
                */}
                {/* OCULTO: EDIT
                <th rowSpan={2} className="text-center col-edit">{toUpperCase("EDIT")}</th>
                */}
                {/* OCULTO: TIPO - el filtro sigue funcional */}
                <th rowSpan={2} className="text-center col-tipo" style={{ display: "none" }}>
                  {toUpperCase("TIPO")}
                </th>
                <th colSpan="3" className="text-center col-importes status-100">
                  {toUpperCase("Facturación")}
                </th>
              </tr>
              <tr>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>
                  {toUpperCase("YTD")}
                </th>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>
                  {toUpperCase("AA")}
                </th>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>
                  {toUpperCase("HTD")}
                </th>
              </tr>
            </thead>
            {filtrarClientes().length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="12" className="text-center">
                    No hay data según los filtros seleccionados :(
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {filtrarClientes().map((cliente, index) => {
                  const isOdd = index % 2 === 0;
                  // Proyecto Contactos, Fase 2: TODOS los contactos por lado (sin tope de 4),
                  // `contactosPorLado` — `sortContacts` sigue resolviendo id→usuario y ordenando
                  // igual que siempre, ahora sobre la lista completa en vez de los 4 escalares.
                  const agenciaContacts = sortContacts(
                    contactosPorLado.agencia.get(cliente.id) || [],
                    usuarios,
                    "agencia",
                    ["Director de cuenta", "Supervisor de cuenta", "Planificador", "Asistente"]
                  );
                  const clienteContacts = sortContacts(
                    contactosPorLado.cliente.get(cliente.id) || [],
                    usuarios,
                    "cliente",
                    [
                      "Director de marketing",
                      "Gerente de marketing",
                      "Subgerente de marketing",
                      "Brand manager",
                      "Jefe de medios",
                      "Asistente de marketing",
                    ]
                  );
                  const agenciaExpandido = contactosExpandido.has(`${cliente.id}|agencia`);
                  const clienteExpandido = contactosExpandido.has(`${cliente.id}|cliente`);
                  const ventasMoneda = todasLasOportunidades
                    .filter((op) => op.client_id === cliente.id && op.estatus === "100%")
                    .every((op) => op.moneda_dolar)
                    ? "US$"
                    : getMonedaSymbol();
                  return (
                    <React.Fragment key={`pair-${index}`}>
                      <tr
                        className={isOdd ? styles.oddPair : styles.evenPair}
                        data-pair-index={index}
                        data-bg={isOdd ? "odd" : "even"}
                      >
                        <td
                          className="text-start"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}
                        >
                          <strong style={{ fontSize: "1.1rem" }}>
                            {toUpperCase(cliente.empresa || cliente.nombre || "—")}
                          </strong>
                          <br />
                          {cliente.empresa && cliente.empresa !== cliente.producto && (
                            <>
                              <span style={{ fontSize: "1.0rem" }}>{toUpperCase(cliente.producto || "")}</span>
                              <br />
                            </>
                          )}
                          {(() => {
                            const estatusFiltroActivo = filtroEstatus.filter((e) => e !== "sinPropuesta");
                            const clientOpportunities = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
                              .filter((op) => {
                                if (op.client_id !== cliente.id) return false;
                                const esAbierta =
                                  op.estatus === "90%" ||
                                  op.estatus === "75%" ||
                                  op.estatus === "50%" ||
                                  (op.status < 100 && op.status > 0);
                                if (!esAbierta) return false;
                                // Fix C: si hay estatus de pipeline seleccionados, mostrar solo esos.
                                if (estatusFiltroActivo.length > 0) {
                                  return estatusFiltroActivo.includes(op.estatus || `${op.status}%`);
                                }
                                return true;
                              })
                              .sort((a, b) => {
                                const priority = { "90%": 0, "75%": 1, "50%": 2 };
                                const priA = priority[a.estatus || `${a.status}%`] ?? 3;
                                const priB = priority[b.estatus || `${b.status}%`] ?? 3;
                                if (priA !== priB) return priA - priB;
                                const importeA = convertirParaSort(a);
                                const importeB = convertirParaSort(b);
                                return importeB - importeA;
                              });
                            return clientOpportunities.length > 0 ? (
                              <span style={{ fontSize: "0.85rem" }}>
                                {toUpperCase(clientOpportunities[0].campana || "")}
                              </span>
                            ) : (
                              <span style={{ fontSize: "0.85rem" }} />
                            );
                          })()}
                        </td>
                        <td
                          className="text-start"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "top" }}
                        >
                          {cliente.agencia && !AGENCIAS_DIRECTAS.includes(Number(cliente.agencia)) ? (
                            <>
                              <div className="fw-bold">{getIntermediarioNombre(cliente.agencia)}</div>
                              {agenciaContacts.length > 0 ? (
                                renderListaContactos(agenciaContacts, cliente.id, "agencia", agenciaExpandido)
                              ) : (
                                <div style={{ paddingLeft: "10px", color: "#666", fontStyle: "italic" }}>
                                  Sin contactos de agencia
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="fw-bold text-success">Trato directo</div>
                          )}
                        </td>
                        <td
                          className="text-end"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", position: "relative" }}
                        >
                          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {(() => {
                              const estatusFiltroActivo = filtroEstatus.filter((e) => e !== "sinPropuesta");
                              const clientOpportunities = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
                                .filter((op) => {
                                  if (op.client_id !== cliente.id) return false;
                                  // Filtro de grupo Perú (Visiona/AdLab) de la celda OPORTUNIDADES.
                                  // matchGrupoOpp decide PER-CUENTA (broker_id): toda opp de una
                                  // cuenta cae del mismo lado que la cuenta en la tabla.
                                  if (
                                    filtroEjecutivo.startsWith("grupo:") &&
                                    !matchGrupoOpp(filtroEjecutivo, op, cliente, btlOppSet.has(op))
                                  ) {
                                    return false;
                                  }
                                  const esAbierta =
                                    op.estatus === "90%" ||
                                    op.estatus === "75%" ||
                                    op.estatus === "50%" ||
                                    (op.status < 100 && op.status > 0);
                                  if (!esAbierta) return false;
                                  // Fix C: si hay estatus de pipeline seleccionados, mostrar solo esos.
                                  if (estatusFiltroActivo.length > 0) {
                                    return estatusFiltroActivo.includes(op.estatus || `${op.status}%`);
                                  }
                                  return true;
                                })
                                .sort((a, b) => {
                                  const priority = { "90%": 0, "75%": 1, "50%": 2 };
                                  const priA = priority[a.estatus || `${a.status}%`] ?? 3;
                                  const priB = priority[b.estatus || `${b.status}%`] ?? 3;
                                  if (priA !== priB) return priA - priB;
                                  const importeA = convertirParaSort(a);
                                  const importeB = convertirParaSort(b);
                                  return importeB - importeA;
                                });
                              return clientOpportunities.length > 0
                                ? clientOpportunities.map((oportunidad, index) => (
                                    <React.Fragment key={`oportunidad-${cliente.id}-${oportunidad.id}`}>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-end",
                                          gap: "2px",
                                        }}
                                      >
                                        <span
                                          className={styles.badgeOportunidad}
                                          style={{
                                            color: getColorForStatus(oportunidad.estatus || `${oportunidad.status}%`),
                                          }}
                                        >
                                          {viewInUSD
                                            ? formatMoneda(
                                                getImporteEnUSD(oportunidad, getDolarValue, fallbackRate),
                                                true
                                              )
                                            : formatMoneda(
                                                oportunidad.importe || oportunidad.total_investment,
                                                oportunidad.moneda_dolar
                                              )}
                                        </span>
                                        {(() => {
                                          const dateInfo = getOportunidadDateStatus(oportunidad);
                                          if (dateInfo.isActive) {
                                            return (
                                              <div className={styles.dateInfoBlock}>
                                                {dateInfo.hasUpdate && dateInfo.daysSinceUpdate != null && (
                                                  <div
                                                    className={`${styles.updateInfo} ${styles[`updateInfo_${dateInfo.severity}`] || ""}`}
                                                  >
                                                    {dateInfo.daysSinceUpdate === 0
                                                      ? "Update: hoy"
                                                      : `Update: ${dateInfo.daysSinceUpdate} día${dateInfo.daysSinceUpdate > 1 ? "s" : ""}`}
                                                  </div>
                                                )}
                                                {dateInfo.daysSinceCreated != null && (
                                                  <div className={styles.createdInfo}>
                                                    {dateInfo.daysSinceCreated === 0
                                                      ? "Creada: hoy"
                                                      : `Creada: ${dateInfo.daysSinceCreated} día${dateInfo.daysSinceCreated > 1 ? "s" : ""}`}
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          }
                                          return (
                                            <div className={styles.dateInfoBlock}>
                                              {dateInfo.createdLabel && (
                                                <div className={styles.createdInfo}>Creada {dateInfo.createdLabel}</div>
                                              )}
                                              {dateInfo.updatedLabel &&
                                                dateInfo.updatedLabel !== dateInfo.createdLabel && (
                                                  <div className={styles.createdInfo}>
                                                    Cerrada {dateInfo.updatedLabel}
                                                  </div>
                                                )}
                                            </div>
                                          );
                                        })()}
                                        {(rol === "superadmin" ||
                                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                                          (rol === "gerencia" &&
                                            (cliente.ejecutivos_asignados?.includes(Number(id)) ||
                                              String(id) === String(cliente.ejecutivo))) ||
                                          (rol === "comercial" &&
                                            (cliente.ejecutivos_asignados?.includes(Number(id)) ||
                                              String(id) === String(cliente.ejecutivo)))) && (
                                          <div style={{ display: "flex", gap: "5px", alignItems: "flex-end" }}>
                                            <TiFlash
                                              style={{ cursor: "pointer", fontSize: "1rem", color: "#555" }}
                                              onClick={() => handleFlashEdit(oportunidad)}
                                            />
                                            <FaEdit
                                              style={{ cursor: "pointer", fontSize: "1rem", color: "#555" }}
                                              onClick={() => handleEdit(oportunidad)}
                                            />
                                            {!oportunidad.esContrato && (
                                              <FaTrash
                                                style={{ cursor: "pointer", fontSize: "0.9rem", color: "#555" }}
                                                onClick={() => handleEliminarOportunidad(oportunidad)}
                                              />
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      {index < clientOpportunities.length - 1 && clientOpportunities.length >= 2 && (
                                        <hr
                                          style={{
                                            width: "95%",
                                            margin: "5px 1px auto",
                                            borderTop: "1px solid #999",
                                            opacity: 0.5,
                                          }}
                                        />
                                      )}
                                    </React.Fragment>
                                  ))
                                : "-";
                            })()}
                          </div>
                        </td>
                        {/* Movimientos futuros — lado AGENCIA (fila superior del par) */}
                        <td
                          className="text-center"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "middle" }}
                        >
                          {renderMovFuturosCell(cliente, "agencia")}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          <ActividadesRecientes
                            actividades={actividadesCRM[cliente.id] || []}
                            usuarios={usuarios}
                            tipoFiltro="agencia"
                            maxItems={5}
                            loading={loadingCRM}
                            ultimaFechaHistorica={ultimaActividadPorLado[cliente.id]?.agencia || null}
                            modoAdLab={modoAdLabActividad}
                            cliente={cliente}
                            contactIds={contactosPorLado.agencia.get(cliente.id) || []}
                            gruposPrecalculados={
                              LEER_ACTIVIDAD_PRECALCULADA ? gruposActividadCRM[cliente.id]?.agencia || [] : null
                            }
                          />
                        </td>
                        {/* OCULTO: PRÓXIMO CONTACTO AGENCIA
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editProximoContacto}>
                                  <DatePicker
                                    selected={proximo_contacto_fecha_agencia}
                                    onChange={(date) => setProximoContactoFechaAgencia(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    minDate={new Date()}
                                    maxDate={() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 3);
                                      return maxDate;
                                    }}
                                    startDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                    monthsShown={3}
                                  />
                                </div>
                              ) : cliente.proximo_contacto_fecha_agencia ? (
                                (() => {
                                  const text = getDaysDifference(cliente.proximo_contacto_fecha_agencia, true);
                                  const status = getStatusFromText(text, true);
                                  return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                })()
                              ) : (
                                "-"
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editProximoContacto}>
                                  <select
                                    value={proximo_contacto_accion_agencia}
                                    className={styles.smallInput}
                                    onChange={(e) => setProximoContactoAccionAgencia(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                </div>
                              ) : (
                                toUpperCase(cliente.proximo_contacto_accion_agencia || "-")
                              )}
                        </td>
                        */}
                        {/* OCULTO: EDIT AGENCIA
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" &&
                            (String(id) === String(cliente.ejecutivo) ||
                              cliente.ejecutivos_asignados?.includes(Number(id)))) ||
                          rol === "comercial" ? (
                                !editingAgenciaContact ? (
                                  <FaEdit
                                    onClick={() => {
                                      setEditingClienteId(cliente.id);
                                      setEditingAgenciaContact(cliente.id);
                                      setUltimoContactoFechaAgencia(
                                        cliente.ultimo_contacto_fecha_agencia
                                          ? parseLocalDate(cliente.ultimo_contacto_fecha_agencia)
                                          : null
                                      );
                                      setUltimoContactoAccionAgencia(cliente.ultimo_contacto_accion_agencia || "");
                                      setProximoContactoFechaAgencia(
                                        cliente.proximo_contacto_fecha_agencia
                                          ? parseLocalDate(cliente.proximo_contacto_fecha_agencia)
                                          : null
                                      );
                                      setProximoContactoAccionAgencia(cliente.proximo_contacto_accion_agencia || "");
                                    }}
                                  />
                                ) : editingAgenciaContact === cliente.id ? (
                                  <FiSave
                                    onClick={() =>
                                      handleUpdateCliente(
                                        cliente.id,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        ultimo_contacto_fecha_agencia,
                                        ultimo_contacto_accion_agencia,
                                        proximo_contacto_fecha_agencia,
                                        proximo_contacto_accion_agencia,
                                        cliente.contacto_cliente,
                                        cliente.contacto_agencia,
                                        tipoCliente
                                      )
                                        .then(() => {
                                          setEditingAgenciaContact(null);
                                          toast.success("Datos guardados exitosamente");
                                        })
                                        .catch((error) => {
                                          console.error("Error al guardar:", error);
                                          toast.error("Error al guardar los datos");
                                        })
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (
                                "-"
                              )}
                        </td>
                        */}
                        {/* OCULTO: TIPO - el filtro sigue funcional */}
                        <td
                          className="text-center"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", display: "none" }}
                        >
                          {toUpperCase(cliente.categoria_cliente || "-")}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasYTD[cliente.id] !== undefined && ventasData.ventasYTD[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasYTD[cliente.id], viewInUSD || ventasMoneda === "US$")
                            : "-"}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasAA[cliente.id] !== undefined && ventasData.ventasAA[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasAA[cliente.id], viewInUSD || ventasMoneda === "US$")
                            : "-"}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasHTD[cliente.id] !== undefined && ventasData.ventasHTD[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasHTD[cliente.id], viewInUSD || ventasMoneda === "US$")
                            : "-"}
                        </td>
                      </tr>
                      <tr
                        className={isOdd ? styles.oddPair : styles.evenPair}
                        data-pair-index={index}
                        data-bg={isOdd ? "odd" : "even"}
                      >
                        <td
                          className="text-start"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "top" }}
                        >
                          <div className="fw-bold">Cliente</div>
                          {clienteContacts.length > 0 ? (
                            renderListaContactos(clienteContacts, cliente.id, "cliente", clienteExpandido)
                          ) : (
                            <div
                              style={{ paddingLeft: "10px", color: "#dc3545", fontStyle: "italic", fontWeight: "bold" }}
                            >
                              Sin contactos del cliente
                            </div>
                          )}
                        </td>
                        {/* Movimientos futuros — lado CLIENTE (fila inferior del par) */}
                        <td
                          className="text-center"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "middle" }}
                        >
                          {renderMovFuturosCell(cliente, "cliente")}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          <ActividadesRecientes
                            actividades={actividadesCRM[cliente.id] || []}
                            usuarios={usuarios}
                            tipoFiltro="cliente"
                            maxItems={5}
                            loading={loadingCRM}
                            ultimaFechaHistorica={ultimaActividadPorLado[cliente.id]?.cliente || null}
                            modoAdLab={modoAdLabActividad}
                            cliente={cliente}
                            contactIds={contactosPorLado.cliente.get(cliente.id) || []}
                            gruposPrecalculados={
                              LEER_ACTIVIDAD_PRECALCULADA ? gruposActividadCRM[cliente.id]?.cliente || [] : null
                            }
                          />
                        </td>
                        {/* OCULTO: PRÓXIMO CONTACTO CLIENTE
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  cliente.proximo_contacto_fecha_cliente ? (
                                    (() => {
                                      const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                      const status = getStatusFromText(text, true);
                                      return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                    })()
                                  ) : (
                                    "-"
                                  )
                                ) : editingClienteContact === cliente.id ? (
                                  <DatePicker
                                    selected={proximo_contacto_fecha_cliente}
                                    onChange={(date) => setProximoContactoFechaCliente(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    minDate={new Date()}
                                    maxDate={() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 3);
                                      return maxDate;
                                    }}
                                    startDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                    monthsShown={3}
                                  />
                                ) : cliente.proximo_contacto_fecha_cliente ? (
                                  (() => {
                                    const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                    const status = getStatusFromText(text, true);
                                    return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                  })()
                                ) : (
                                  "-"
                                )
                              ) : cliente.proximo_contacto_fecha_cliente ? (
                                (() => {
                                  const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                  const status = getStatusFromText(text, true);
                                  return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                })()
                              ) : (
                                "-"
                              )}
                        </td>
                        <td style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                                ) : editingClienteContact === cliente.id ? (
                                  <select
                                    value={proximo_contacto_accion_cliente}
                                    className={styles.smallInput}
                                    onChange={(e) => setProximoContactoAccionCliente(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                ) : (
                                  toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                                )
                              ) : (
                                toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                              )}
                        </td>
                        */}
                        {/* OCULTO: EDIT CLIENTE
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" &&
                            (String(id) === String(cliente.ejecutivo) ||
                              cliente.ejecutivos_asignados?.includes(Number(id)))) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  <FaEdit
                                    onClick={() => {
                                      setEditingClienteId(cliente.id);
                                      setEditingClienteContact(cliente.id);
                                      setUltimoContactoFechaCliente(
                                        cliente.ultimo_contacto_fecha_cliente
                                          ? parseLocalDate(cliente.ultimo_contacto_fecha_cliente)
                                          : null
                                      );
                                      setUltimoContactoAccionCliente(cliente.ultimo_contacto_accion_cliente || "");
                                      setProximoContactoFechaCliente(
                                        cliente.proximo_contacto_fecha_cliente
                                          ? parseLocalDate(cliente.proximo_contacto_fecha_cliente)
                                          : null
                                      );
                                      setProximoContactoAccionCliente(cliente.proximo_contacto_accion_cliente || "");
                                    }}
                                  />
                                ) : editingClienteContact === cliente.id ? (
                                  <FiSave
                                    onClick={() =>
                                      handleUpdateCliente(
                                        cliente.id,
                                        cliente.ejecutivo,
                                        cliente.agencia,
                                        ultimo_contacto_fecha_cliente,
                                        ultimo_contacto_accion_cliente,
                                        proximo_contacto_fecha_cliente,
                                        proximo_contacto_accion_cliente,
                                        null,
                                        null,
                                        null,
                                        null,
                                        cliente.contacto_cliente,
                                        cliente.contacto_agencia,
                                        tipoCliente
                                      )
                                        .then(() => {
                                          setEditingClienteContact(null);
                                          toast.success("Datos guardados exitosamente");
                                        })
                                        .catch((error) => {
                                          console.error("Error al guardar:", error);
                                          toast.error("Error al guardar los datos");
                                        })
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (
                                "-"
                              )}
                        </td>
                        */}
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
          {isModalOpen && (
            <div
              className="modal"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "5px",
                  minWidth: "200px",
                  textAlign: "center",
                }}
              >
                <h5>Cambiar estatus de oportunidad</h5>
                <div style={{ marginTop: "15px" }}>
                  {selectedOportunidadId && (
                    <div>
                      {todasLasOportunidades.find((op) => op.id === selectedOportunidadId && op.estatus === "90%") && (
                        <>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("100%"),
                              color: getLabelColorForStatus("100%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "100%");
                              setIsModalOpen(false);
                            }}
                          >
                            100%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("75%"),
                              color: getLabelColorForStatus("75%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "75%");
                              setIsModalOpen(false);
                            }}
                          >
                            75%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("50%"),
                              color: getLabelColorForStatus("50%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "50%");
                              setIsModalOpen(false);
                            }}
                          >
                            50%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("0%"),
                              color: getLabelColorForStatus("0%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "0%");
                              setIsModalOpen(false);
                            }}
                          >
                            0%
                          </button>
                        </>
                      )}
                      {todasLasOportunidades.find((op) => op.id === selectedOportunidadId && op.estatus === "75%") && (
                        <>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("100%"),
                              color: getLabelColorForStatus("100%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "100%");
                              setIsModalOpen(false);
                            }}
                          >
                            100%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("90%"),
                              color: getLabelColorForStatus("90%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "90%");
                              setIsModalOpen(false);
                            }}
                          >
                            90%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("50%"),
                              color: getLabelColorForStatus("50%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "50%");
                              setIsModalOpen(false);
                            }}
                          >
                            50%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("0%"),
                              color: getLabelColorForStatus("0%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "0%");
                              setIsModalOpen(false);
                            }}
                          >
                            0%
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
                <button
                  style={{
                    marginTop: "15px",
                    padding: "5px 10px",
                    backgroundColor: "grey",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
          <FlashEditModal
            isOpen={isFlashEditing}
            onClose={() => {
              setIsFlashEditing(false);
              setFlashEditingOpportunity(null);
            }}
            opportunity={flashEditingOpportunity}
            onSave={onSubmitFlashEdit}
            saving={flashSaving}
            hideFacturacion={flashEditingOpportunity?.esContrato}
            intermediarios={intermediarios}
            clientes={clientes}
          />
          <AgendarMovimientoModal
            isOpen={agendarOpen}
            onClose={handleCloseAgendar}
            onSave={handleSaveAgendar}
            onDelete={handleDeleteAgendar}
            saving={agendarSaving}
            deleting={agendarDeleting}
            clienteNombre={agendarCtx?.cliente?.empresa || agendarCtx?.cliente?.nombre || ""}
            lado={agendarCtx?.lado || ""}
            evento={agendarCtx?.evento || null}
          />
        </>
      )}
    </div>
  );
};
